/* Motor de la Calculadora Dubovik: datos, lector de ingredientes, solver y cálculo por categoría */
var MOTOR = (function () {
  'use strict';

  /* =========================================================
     1. Texto: normalización, plegado fonético y distancia
     ========================================================= */

  function normalizar(t) {
    return (t || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }
  function limpiar(t) {
    return normalizar(t).replace(/[^a-z0-9 ]/g, ' ').replace(/\s+/g, ' ').trim();
  }
  // Pliega diferencias típicas de escritura: z/s, v/b, h muda, c suave, dobles, plurales
  function plegar(t) {
    return t.split(' ').map(function (w) {
      var s = w.replace(/ph/g, 'f').replace(/h/g, '').replace(/z/g, 's').replace(/v/g, 'b')
        .replace(/ll/g, 'y').replace(/qu/g, 'k').replace(/c(?=[ei])/g, 's').replace(/c/g, 'k')
        .replace(/(.)\1+/g, '$1');
      if (s.length >= 5 && /s$/.test(s)) s = s.slice(0, -1);
      return s;
    }).join(' ');
  }
  function distancia(a, b) {
    var la = a.length, lb = b.length, i, j;
    if (!la) return lb;
    if (!lb) return la;
    var prev2 = null, prev = [], cur;
    for (j = 0; j <= lb; j++) prev.push(j);
    for (i = 1; i <= la; i++) {
      cur = [i];
      for (j = 1; j <= lb; j++) {
        var costo = a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1;
        var v = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + costo);
        if (i > 1 && j > 1 && a.charAt(i - 1) === b.charAt(j - 2) && a.charAt(i - 2) === b.charAt(j - 1)) v = Math.min(v, prev2[j - 2] + 1);
        cur.push(v);
      }
      prev2 = prev;
      prev = cur;
    }
    return prev[lb];
  }

  /* =========================================================
     2. Constantes de la escuela
     ========================================================= */

  var K = {
    PAC_ALCOHOL: 7.43,          // 342 / 46,07
    DENS_ALCOHOL: 0.78,         // convención de la escuela
    POD_LACTOSA: 0.16,
    FRUTA_POD: 1.44, FRUTA_PAC: 1.88,
    CORVITTO_CSG: 1.8, CORVITTO_MC: 0.9,
    LPE: { prot: 0.263, grasa: 0.267, lac: 0.384 },   // leche entera en polvo (USDA)
    LPD: { prot: 0.362, grasa: 0.008, lac: 0.52 },    // leche descremada en polvo (USDA)
    PROT_CSG: 0.227,            // proteína del cacao sin grasa (USDA cacao en polvo)
    COLESTEROL_GL: 2.65,        // mg de colesterol por g de grasa láctea (USDA mantequilla)
    LACTOSA_PROT: { c: 1.5, min: 1.4, max: 1.7 }
  };

  /* =========================================================
     3. Diccionario de ingredientes (por 100 g)
     ========================================================= */

  var ENTRADAS = [];
  var POR_ID = {};
  var CAMPOS = ['agua', 'prot', 'grasa', 'azuc', 'carb', 'fib', 'alc', 'lac', 'acid', 'pac', 'pod'];

  function completar(c) {
    var o = {};
    CAMPOS.forEach(function (k) { o[k] = c[k] || 0; });
    if (!c.carb && c.azuc) o.carb = c.azuc;
    o.kcal = 4 * o.prot + 9 * o.grasa + 7 * o.alc + 2 * o.fib + (c.poliol ? 2.4 : 4) * o.carb;
    if (c.kcal0) o.kcal = 4 * o.prot + 9 * o.grasa;
    return o;
  }

  function def(id, nombre, grupo, c, sin, extra) {
    extra = extra || {};
    var e = {
      id: id, nombre: nombre, grupo: grupo, c: completar(c), max: extra.max || null,
      variantes: extra.variantes ? extra.variantes.map(function (v) { return { tag: v.tag, c: completar(v.c) }; }) : null,
      aditivo: !!extra.aditivo, nota: extra.nota || null, sinValor: !!extra.sinValor,
      intenso: !!extra.intenso, negativo: !!extra.negativo, alcohol: !!(c.alc), sinonimos: sin || []
    };
    if (e.variantes) e.c = e.variantes[0].c;
    ENTRADAS.push(e);
    POR_ID[id] = e;
    return e;
  }

  /* --- Azúcares y edulcorantes --- */
  def('sacarosa', 'Sacarosa (azúcar)', 'Azúcares y edulcorantes', { azuc: 100, pac: 100, pod: 100 },
    ['azucar', 'azucar blanca', 'azucar granulada', 'azucar refinada', 'azucar de cana', 'azucar rubia', 'azucar morena',
      'azucar mascabo', 'azucar integral', 'azucar flor', 'azucar impalpable', 'azucar glas', 'sacarosa', 'sugar', 'cane sugar',
      'beet sugar', 'white sugar', 'brown sugar', 'icing sugar', 'powdered sugar', 'sucrose', 'zucchero', 'zucchero di canna',
      'zucchero a velo', 'saccarosio']);
  def('dextrosa', 'Dextrosa', 'Azúcares y edulcorantes', {}, ['dextrosa', 'dextrosa monohidrato', 'dextrosa anhidra',
    'destrosio', 'destrosio monoidrato', 'dextrose', 'dextrose monohydrate', 'anhydrous dextrose'], {
      variantes: [
        { tag: 'monohidratada', c: { agua: 9, azuc: 91, pac: 173, pod: 80 } },
        { tag: 'anhidra', c: { azuc: 100, pac: 190, pod: 88 } }
      ]
    });
  def('fructosa', 'Fructosa', 'Azúcares y edulcorantes', { azuc: 100, pac: 190, pod: 170 },
    ['fructosa', 'fructose', 'fruttosio', 'levulosa', 'cristales de fructosa']);
  def('glucosaLiquida', 'Jarabe de glucosa', 'Azúcares y edulcorantes', {}, ['jarabe de glucosa', 'glucosa', 'glucosa liquida',
    'jarabe de maiz', 'sciroppo di glucosio', 'glucose syrup', 'corn syrup', 'glucose', 'glucosio', 'jarabe de glucosa de maiz'], {
      variantes: [
        { tag: 'DE 40', c: { agua: 20, azuc: 28, carb: 80, pac: 61, pod: 32 } },
        { tag: 'DE 60', c: { agua: 20, azuc: 50, carb: 80, pac: 91, pod: 48 } }
      ]
    });
  def('glucosaDeshidratada', 'Jarabe de glucosa deshidratado', 'Azúcares y edulcorantes', {}, ['jarabe de glucosa deshidratado',
    'jarabe de glucosa en polvo', 'glucosa deshidratada', 'glucosa atomizada', 'solidos de jarabe de glucosa', 'dried glucose syrup',
    'glucose syrup solids', 'dehydrated glucose syrup', 'sciroppo di glucosio disidratato', 'glucosio disidratato', 'glucosio atomizzato'], {
      variantes: [
        { tag: 'DE 30', c: { agua: 4, azuc: 24, carb: 96, pac: 55, pod: 25 } },
        { tag: 'DE 40', c: { agua: 4, azuc: 34, carb: 96, pac: 76, pod: 45 } }
      ]
    });
  def('glucosaPolvo', 'Glucosa en polvo', 'Azúcares y edulcorantes', {}, ['glucosa en polvo', 'glucosio in polvere',
    'glucose powder', 'dried glucose', 'polvo de glucosa'], {
      variantes: [
        { tag: 'jarabe deshidratado DE 40', c: { agua: 4, azuc: 34, carb: 96, pac: 76, pod: 45 } },
        { tag: 'dextrosa', c: { agua: 9, azuc: 91, pac: 173, pod: 80 } }
      ]
    });
  def('maltodextrina', 'Maltodextrina', 'Azúcares y edulcorantes', {},
    ['maltodextrina', 'maltodextrin', 'maltodestrina', 'dextrina', 'dextrin', 'destrina'], {
      variantes: [
        { tag: 'DE 18', c: { agua: 5, azuc: 5, carb: 95, pac: 34, pod: 10 } },
        { tag: 'DE 12', c: { agua: 5, azuc: 3, carb: 95, pac: 23, pod: 5 } }
      ]
    });
  def('jmaf', 'Jarabe de alta fructosa', 'Azúcares y edulcorantes', { agua: 24, azuc: 76, pac: 144, pod: 91 },
    ['jarabe de maiz de alta fructosa', 'jarabe de alta fructosa', 'jarabe de glucosa fructosa', 'jarabe de fructosa glucosa',
      'high fructose corn syrup', 'glucose fructose syrup', 'fructose glucose syrup', 'isoglucosa', 'sciroppo di glucosio fruttosio',
      'jarabe de maiz alto en fructosa']);
  def('invertido', 'Azúcar invertido', 'Azúcares y edulcorantes', { agua: 22, azuc: 78, pac: 190, pod: 120 },
    ['azucar invertido', 'jarabe de azucar invertido', 'jarabe invertido', 'almibar invertido', 'invert sugar', 'invert sugar syrup',
      'invert syrup', 'zucchero invertito', 'trimoline']);
  def('miel', 'Miel', 'Azúcares y edulcorantes', { agua: 17, prot: 0.3, azuc: 82, pac: 154, pod: 118 },
    ['miel', 'miel de abeja', 'honey', 'miele']);
  def('lactosa', 'Lactosa', 'Azúcares y edulcorantes', { azuc: 100, lac: 100, pac: 100, pod: 16 },
    ['lactosa', 'lactose', 'lattosio']);
  def('trehalosa', 'Trehalosa', 'Azúcares y edulcorantes', { azuc: 100, pac: 100, pod: 45 },
    ['trehalosa', 'trehalose', 'trealosio']);
  def('sorbitol', 'Sorbitol', 'Azúcares y edulcorantes', { carb: 100, pac: 188, pod: 60, poliol: true }, ['sorbitol', 'sorbitolo', 'jarabe de sorbitol']);
  def('maltitol', 'Maltitol', 'Azúcares y edulcorantes', { carb: 100, pac: 99, pod: 90, poliol: true }, ['maltitol', 'maltitolo', 'jarabe de maltitol']);
  def('eritritol', 'Eritritol', 'Azúcares y edulcorantes', { carb: 100, pac: 280, pod: 65, kcal0: true }, ['eritritol', 'erythritol', 'eritritolo']);
  def('xilitol', 'Xilitol', 'Azúcares y edulcorantes', { carb: 100, pac: 225, pod: 100, poliol: true }, ['xilitol', 'xylitol', 'xilitolo']);
  def('isomalt', 'Isomalt', 'Azúcares y edulcorantes', { carb: 100, pac: 99, pod: 50, poliol: true }, ['isomalt', 'isomaltitol', 'isomalto']);
  def('lactitol', 'Lactitol', 'Azúcares y edulcorantes', { carb: 100, pac: 99, pod: 35, poliol: true }, ['lactitol', 'lactitolo']);
  def('glicerol', 'Glicerol', 'Azúcares y edulcorantes', { carb: 100, pac: 372, pod: 60, poliol: true }, ['glicerina', 'glicerol', 'glycerol', 'glycerin', 'glycerine', 'glicerolo'], { max: 10 });
  def('alulosa', 'Alulosa', 'Azúcares y edulcorantes', { carb: 100, pac: 190, pod: 70, kcal0: true }, ['alulosa', 'allulose', 'psicosa', 'alulosio']);
  def('inulina', 'Inulina', 'Azúcares y edulcorantes', { agua: 5, fib: 90, pac: 5, pod: 10 }, ['inulina', 'inulin', 'fibra de achicoria', 'fibra di cicoria']);
  def('fos', 'Oligofructosa (FOS)', 'Azúcares y edulcorantes', { agua: 5, fib: 90, pac: 49, pod: 35 }, ['oligofructosa', 'fructooligosacaridos', 'fos', 'oligofructose', 'fructooligosaccharides'], { nota: 'PAC estimado' });
  def('polidextrosa', 'Polidextrosa', 'Azúcares y edulcorantes', { agua: 4, fib: 90, pac: 15, pod: 0 }, ['polidextrosa', 'polydextrose', 'polidestrosio'], { nota: 'PAC estimado' });
  def('intenso', 'Edulcorante intenso', 'Azúcares y edulcorantes', {}, ['sucralosa', 'sucralose', 'estevia', 'stevia',
    'glucosidos de esteviol', 'steviol glycosides', 'glicosidi steviolici', 'aspartamo', 'aspartame', 'acesulfamo k', 'acesulfamo',
    'acesulfame k', 'acesulfame', 'sacarina', 'saccharin', 'ciclamato', 'cyclamate', 'monk fruit', 'fruta del monje', 'neotamo'],
    { max: 0.5, aditivo: true, intenso: true });

  /* --- Lácteos --- */
  def('leche', 'Leche entera', 'Lácteos', { agua: 88, prot: 3.2, grasa: 3.3, azuc: 4.8, lac: 4.8, pac: 4.8, pod: 0.8 },
    ['leche', 'leche entera', 'leche fresca', 'leche pasteurizada', 'whole milk', 'milk', 'fresh milk', 'latte', 'latte intero', 'latte fresco']);
  def('lecheDescremada', 'Leche descremada', 'Lácteos', { agua: 91, prot: 3.4, grasa: 0.2, azuc: 5, lac: 5, pac: 5, pod: 0.8 },
    ['leche descremada', 'leche desnatada', 'skimmed milk', 'skim milk', 'latte scremato']);
  def('lpe', 'Leche entera en polvo', 'Lácteos', { agua: 2.5, prot: 26.3, grasa: 26.7, azuc: 38.4, lac: 38.4, pac: 38.4, pod: 6.1 },
    ['leche en polvo', 'leche entera en polvo', 'leche en polvo entera', 'whole milk powder', 'milk powder', 'dried whole milk',
      'latte intero in polvere', 'latte in polvere', 'polvere di latte intero']);
  def('lpd', 'Leche descremada en polvo', 'Lácteos', { agua: 3.2, prot: 36.2, grasa: 0.8, azuc: 52, lac: 52, pac: 52, pod: 8.3 },
    ['leche descremada en polvo', 'leche en polvo descremada', 'leche desnatada en polvo', 'leche en polvo desnatada',
      'skimmed milk powder', 'skim milk powder', 'nonfat dry milk', 'non fat dry milk', 'latte scremato in polvere',
      'latte magro in polvere', 'latte spray magro', 'latte magro']);
  def('suero', 'Suero de leche en polvo', 'Lácteos', { agua: 3.2, prot: 12.9, grasa: 1.1, azuc: 74.5, lac: 74.5, pac: 74.5, pod: 11.9 },
    ['suero de leche en polvo', 'suero en polvo', 'suero lacteo', 'suero de leche', 'suero dulce', 'suero', 'lactosuero',
      'whey powder', 'sweet whey powder', 'sweet whey', 'whey', 'siero di latte in polvere', 'siero di latte', 'siero']);
  def('protSuero', 'Proteínas de suero', 'Lácteos', {}, ['proteinas de suero', 'proteina de suero', 'proteinas del suero',
    'concentrado de proteinas de suero', 'whey protein', 'whey proteins', 'whey protein concentrate', 'proteine del siero',
    'proteine del siero di latte', 'wpc'], {
      variantes: [
        { tag: 'suero en polvo (13% proteína)', c: { agua: 3.2, prot: 12.9, grasa: 1.1, azuc: 74.5, lac: 74.5, pac: 74.5, pod: 11.9 } },
        { tag: 'WPC 35', c: { agua: 4, prot: 35, grasa: 4, azuc: 50, lac: 50, pac: 50, pod: 8 } },
        { tag: 'WPC 80', c: { agua: 4, prot: 80, grasa: 6, azuc: 6, lac: 6, pac: 6, pod: 1 } }
      ]
    });
  def('protLactea', 'Proteínas lácteas', 'Lácteos', { agua: 5, prot: 82, grasa: 1.5, azuc: 5, lac: 5, pac: 5, pod: 0.8 },
    ['proteinas lacteas', 'proteina lactea', 'proteinas de leche', 'proteina de leche', 'caseinato', 'caseinato de sodio',
      'caseinato de calcio', 'caseina', 'milk protein', 'milk proteins', 'milk protein concentrate', 'caseinate', 'sodium caseinate',
      'proteine del latte', 'proteine lattiche', 'caseinato di sodio']);
  def('crema', 'Crema de leche', 'Lácteos', { agua: 57, prot: 2.2, grasa: 35, azuc: 3, lac: 3, pac: 3, pod: 0.5 },
    ['crema de leche', 'crema', 'nata', 'crema fresca', 'cream', 'heavy cream', 'panna', 'panna fresca']);
  def('cremaPolvo', 'Crema en polvo', 'Lácteos', { agua: 2, prot: 13, grasa: 55, azuc: 25, lac: 25, pac: 25, pod: 4 },
    ['crema en polvo', 'nata en polvo', 'cream powder', 'panna in polvere']);
  def('grasaLactea', 'Mantequilla o grasa láctea', 'Lácteos', {}, ['mantequilla', 'manteca de leche', 'butter', 'burro',
    'grasa lactea', 'grasa de leche', 'grasa butirica', 'aceite de mantequilla', 'butteroil', 'butter oil', 'milk fat',
    'anhydrous milk fat', 'butterfat', 'grasso del latte', 'grasso lattiero', 'burro anidro', 'mantequilla clarificada', 'ghee'], {
      variantes: [
        { tag: 'grasa láctea anhidra', c: { grasa: 99.8 } },
        { tag: 'mantequilla', c: { agua: 16, grasa: 82, prot: 0.9, azuc: 0.6, lac: 0.6, pac: 0.6, pod: 0.1 } }
      ]
    });
  def('condensada', 'Leche condensada', 'Lácteos', { agua: 27, prot: 7.9, grasa: 8.7, azuc: 54, lac: 11, pac: 54, pod: 45 },
    ['leche condensada', 'leche condensada azucarada', 'sweetened condensed milk', 'condensed milk', 'latte condensato',
      'latte condensato zuccherato']);
  def('dulceLeche', 'Dulce de leche', 'Lácteos', { agua: 30, prot: 7, grasa: 7, azuc: 50, carb: 52, lac: 10.5, pac: 50, pod: 41 },
    ['dulce de leche', 'manjar', 'manjar blanco', 'cajeta', 'arequipe']);
  def('mascarpone', 'Mascarpone o queso crema', 'Lácteos', { agua: 45, prot: 4.6, grasa: 44, azuc: 3.5, lac: 3.5, pac: 3.5, pod: 0.6 },
    ['mascarpone', 'queso crema', 'queso mascarpone', 'cream cheese', 'formaggio fresco', 'queso']);
  def('yogur', 'Yogur natural', 'Lácteos', { agua: 88, prot: 3.5, grasa: 3.3, azuc: 4.7, lac: 3.5, pac: 4.7, pod: 1 },
    ['yogur', 'yogurt', 'yoghurt', 'yogur natural', 'yogurt intero']);
  def('yogurPolvo', 'Yogur en polvo', 'Lácteos', { agua: 3, prot: 32, grasa: 2, azuc: 48, lac: 40, pac: 48, pod: 8 },
    ['yogur en polvo', 'yogurt en polvo', 'yogurt powder', 'yoghurt powder', 'yogurt in polvere']);

  /* --- Grasas y emulsionantes --- */
  def('grasaVegetal', 'Grasa o aceite vegetal', 'Grasas y emulsionantes', { grasa: 100 },
    ['grasa vegetal', 'grasas vegetales', 'aceite vegetal', 'aceites vegetales', 'aceite de palma', 'grasa de palma', 'palma',
      'aceite de palmiste', 'palmiste', 'aceite de coco', 'grasa de coco', 'aceite de girasol', 'girasol', 'aceite de canola',
      'canola', 'aceite de maravilla', 'aceite de soya', 'aceite de soja', 'aceite de oliva', 'aceite', 'manteca vegetal', 'manteca',
      'vegetable fat', 'vegetable fats', 'vegetable oil', 'vegetable oils', 'palm oil', 'palm fat', 'palm kernel oil',
      'coconut oil', 'coconut fat', 'sunflower oil', 'rapeseed oil', 'canola oil', 'soybean oil', 'olive oil', 'shea butter',
      'grassi vegetali', 'grasso vegetale', 'oli vegetali', 'olio di palma', 'olio di cocco', 'olio di girasole',
      'olio di semi di girasole', 'burro di karite', 'karite', 'grasa', 'margarina']);
  def('lecitina', 'Lecitina', 'Grasas y emulsionantes', { grasa: 90 }, ['lecitina', 'lecitinas', 'lecitina de soya',
    'lecitina de soja', 'lecitina de girasol', 'lecithin', 'lecithins', 'soy lecithin', 'soya lecithin', 'sunflower lecithin',
    'lecitina di soia', 'lecitina di girasole'], { max: 3, aditivo: true });
  def('monodi', 'Mono y diglicéridos', 'Grasas y emulsionantes', { grasa: 85 }, ['mono y digliceridos', 'monodigliceridos',
    'mono y digliceridos de acidos grasos', 'mono and diglycerides', 'mono and diglycerides of fatty acids', 'mono e digliceridi',
    'mono e digliceridi degli acidi grassi', 'monogliceridos'], { max: 15, aditivo: true });
  def('esteres', 'Ésteres emulsionantes', 'Grasas y emulsionantes', { grasa: 75 }, ['acetic acid esters of mono and diglycerides',
    'lactic acid esters of mono and diglycerides', 'citric acid esters of mono and diglycerides', 'acetic acid esters',
    'lactic acid esters', 'esteres acetico de mono y digliceridos', 'esteres lactico de mono y digliceridos', 'esteres acetico',
    'esteres lactico', 'esteri acetici', 'esteri lattici', 'esteri citrici', 'sucroesteres', 'esteres de sacarosa', 'sucrose esters',
    'esteri di saccarosio', 'esteres de poliglicerol', 'polyglycerol esters', 'estearoil lactilato de sodio',
    'sodium stearoyl lactylate', 'polisorbato', 'polysorbate'], { max: 10, aditivo: true });

  /* --- Cacao y chocolate --- */
  def('cacaoMagro', 'Cacao en polvo magro', 'Cacao y chocolate', { agua: 3, prot: 21, grasa: 11, azuc: 1.5, carb: 12, fib: 35, pac: -170, pod: 0 },
    ['cacao magro', 'cacao desgrasado', 'cacao en polvo magro', 'cacao en polvo desgrasado', 'fat reduced cocoa',
      'fat reduced cocoa powder', 'cacao magro in polvere'], { negativo: true });
  def('cacao', 'Cacao en polvo', 'Cacao y chocolate', {}, ['cacao en polvo', 'cacao', 'cacao amargo', 'cacao alcalinizado',
    'cacao natural', 'cocoa powder', 'cocoa', 'cacao in polvere'], {
      negativo: true,
      variantes: [
        { tag: '10-12% de grasa', c: { agua: 3, prot: 21, grasa: 11, azuc: 1.5, carb: 12, fib: 35, pac: -170, pod: 0 } },
        { tag: '20-22% de grasa', c: { agua: 3, prot: 20, grasa: 21, azuc: 1.5, carb: 11, fib: 33, pac: -161, pod: 0 } }
      ]
    });
  def('pastaCacao', 'Pasta de cacao', 'Cacao y chocolate', { agua: 1.5, prot: 12, grasa: 53, azuc: 1, carb: 12, fib: 16, pac: -132, pod: 0 },
    ['pasta de cacao', 'masa de cacao', 'licor de cacao', 'cacao en pasta', 'cocoa mass', 'cocoa liquor', 'cocoa paste',
      'unsweetened chocolate', 'chocolate sin azucar', 'pasta di cacao', 'massa di cacao'], { negativo: true });
  def('mantecaCacao', 'Manteca de cacao', 'Cacao y chocolate', { grasa: 100, pac: -90, pod: 0 },
    ['manteca de cacao', 'mantequilla de cacao', 'grasa de cacao', 'cocoa butter', 'burro di cacao'], { negativo: true });
  def('chocolateNegro', 'Chocolate amargo', 'Cacao y chocolate', { agua: 1, prot: 6, grasa: 35, azuc: 45, carb: 50, fib: 8, pac: -22.5, pod: 45 },
    ['chocolate', 'chocolate amargo', 'chocolate semiamargo', 'chocolate negro', 'chocolate oscuro', 'cobertura de chocolate',
      'chocolate fondant', 'dark chocolate', 'cioccolato', 'cioccolato fondente'], { negativo: true });
  def('chocolateLeche', 'Chocolate con leche', 'Cacao y chocolate', { agua: 1, prot: 7, grasa: 36, azuc: 50, carb: 51, fib: 2, lac: 8.6, pac: 14, pod: 42.8 },
    ['chocolate con leche', 'milk chocolate', 'cioccolato al latte'], { negativo: true });
  def('chocolateBlanco', 'Chocolate blanco', 'Cacao y chocolate', { agua: 1, prot: 6.4, grasa: 34.5, azuc: 55, carb: 56, lac: 9.3, pac: 30, pod: 47 },
    ['chocolate blanco', 'white chocolate', 'cioccolato bianco'], { negativo: true });

  /* --- Frutos secos (pasta pura). PAC: valores fijos de la escuela o 1,4 × grasa --- */
  var FRUTOS_SECOS = [
    { id: 'avellana', nombre: 'Avellana', prot: 14.95, grasa: 60.75, azuc: 4.34, carb: 7.0, fib: 9.7, agua: 5.31, pac: -91, escuela: true,
      sin: ['avellana', 'avellanas', 'pasta de avellana', 'pasta de avellanas', 'avellanas tostadas', 'hazelnut', 'hazelnuts', 'hazelnut paste', 'nocciola', 'nocciole', 'pasta di nocciole', 'nocciole tostate'] },
    { id: 'pistacho', nombre: 'Pistacho', prot: 20.16, grasa: 45.32, azuc: 7.66, carb: 16.57, fib: 10.6, agua: 3.91, pac: -70, escuela: true,
      sin: ['pistacho', 'pistachos', 'pasta de pistacho', 'pistachio', 'pistachios', 'pistachio paste', 'pistacchio', 'pistacchi', 'pasta di pistacchio'] },
    { id: 'mani', nombre: 'Maní', prot: 25.8, grasa: 49.24, azuc: 4.72, carb: 7.63, fib: 8.5, agua: 6.5, pac: -70, escuela: true,
      sin: ['mani', 'cacahuate', 'cacahuete', 'pasta de mani', 'mantequilla de mani', 'crema de mani', 'peanut', 'peanuts', 'peanut butter', 'peanut paste', 'arachidi', 'burro di arachidi'] },
    { id: 'almendra', nombre: 'Almendra', prot: 21.15, grasa: 49.93, azuc: 4.35, carb: 9.05, fib: 12.5, agua: 4.41, pac: -70,
      sin: ['almendra', 'almendras', 'pasta de almendra', 'pasta de almendras', 'almond', 'almonds', 'almond paste', 'mandorla', 'mandorle', 'pasta di mandorle'] },
    { id: 'nuez', nombre: 'Nuez', prot: 15.23, grasa: 65.21, azuc: 2.61, carb: 7.01, fib: 6.7, agua: 4.07, pac: -91,
      sin: ['nuez', 'nueces', 'nuez de nogal', 'walnut', 'walnuts', 'noce', 'noci'] },
    { id: 'caju', nombre: 'Castaña de cajú', prot: 18.22, grasa: 43.85, azuc: 5.91, carb: 26.89, fib: 3.3, agua: 5.2, pac: -61,
      sin: ['anacardo', 'anacardos', 'castana de caju', 'caju', 'cashew', 'cashews', 'anacardi'] },
    { id: 'macadamia', nombre: 'Macadamia', prot: 7.91, grasa: 75.77, azuc: 4.57, carb: 5.22, fib: 8.6, agua: 1.36, pac: -106,
      sin: ['macadamia', 'nuez de macadamia', 'macadamia nuts'] },
    { id: 'sesamo', nombre: 'Sésamo (tahini)', prot: 17.0, grasa: 53.76, azuc: 0.49, carb: 11.89, fib: 9.3, agua: 3.05, pac: -75,
      sin: ['sesamo', 'tahini', 'tahina', 'pasta de sesamo', 'sesame', 'sesame paste', 'semi di sesamo'] }
  ];
  FRUTOS_SECOS.forEach(function (n) {
    def(n.id, n.nombre, 'Frutos secos', { agua: n.agua, prot: n.prot, grasa: n.grasa, azuc: n.azuc, carb: n.carb, fib: n.fib, pac: n.pac, pod: n.azuc },
      n.sin, { negativo: true });
  });
  def('coco', 'Coco rallado', 'Frutos secos', { agua: 3, prot: 7, grasa: 65, azuc: 7, carb: 7, fib: 16, pac: 0, pod: 7 },
    ['coco', 'coco rallado', 'coco deshidratado', 'coconut', 'desiccated coconut', 'cocco', 'cocco rape'], { sinValor: true });

  /* --- Frutas (USDA SR Legacy, aproximado). Acidez típica de literatura --- */
  var FACT_ACIDO = { citrico: 1.78, malico: 2.55, tartarico: 2.28 };
  var FRUTAS = [
    { id: 'frutilla', nombre: 'Frutilla', agua: 90.95, azuc: 4.89, fib: 2.0, prot: 0.67, grasa: 0.30, acid: 1.05, rango: [0.8, 1.2], tipo: 'citrico', sin: ['frutilla', 'frutillas', 'fresa', 'fresas', 'strawberry', 'strawberries', 'fragola', 'fragole'] },
    { id: 'frambuesa', nombre: 'Frambuesa', agua: 85.75, azuc: 4.42, fib: 6.5, prot: 1.20, grasa: 0.65, acid: 1.6, rango: [0.6, 2.9], tipo: 'citrico', sin: ['frambuesa', 'frambuesas', 'raspberry', 'raspberries', 'lampone', 'lamponi'] },
    { id: 'mora', nombre: 'Mora', agua: 88.15, azuc: 4.88, fib: 5.3, prot: 1.39, grasa: 0.49, acid: 1.4, rango: [0.6, 2.9], tipo: 'citrico', sin: ['mora', 'moras', 'blackberry', 'blackberries', 'mora di rovo', 'more'] },
    { id: 'arandano', nombre: 'Arándano', agua: 84.21, azuc: 9.96, fib: 2.4, prot: 0.74, grasa: 0.33, acid: 0.7, rango: [0.4, 1.2], tipo: 'citrico', sin: ['arandano', 'arandanos', 'blueberry', 'blueberries', 'mirtillo', 'mirtilli'] },
    { id: 'platano', nombre: 'Plátano', agua: 74.91, azuc: 12.23, fib: 2.6, prot: 1.09, grasa: 0.33, acid: 0.3, tipo: 'malico', sin: ['platano', 'platanos', 'banana', 'bananas', 'banano'] },
    { id: 'mango', nombre: 'Mango', agua: 83.46, azuc: 13.66, fib: 1.6, prot: 0.82, grasa: 0.38, acid: 0.4, rango: [0.2, 0.8], tipo: 'citrico', sin: ['mango', 'mangos', 'pulpa de mango'] },
    { id: 'pina', nombre: 'Piña', agua: 86.0, azuc: 9.85, fib: 1.4, prot: 0.54, grasa: 0.12, acid: 0.8, rango: [0.6, 1.2], tipo: 'citrico', sin: ['pina', 'anana', 'pineapple', 'ananas'] },
    { id: 'maracuya', nombre: 'Maracuyá (jugo)', agua: 84.21, azuc: 14.25, fib: 0.2, prot: 0.67, grasa: 0.18, acid: 3.5, rango: [2.5, 5.0], tipo: 'citrico', jugo: true, sin: ['maracuya', 'jugo de maracuya', 'passion fruit', 'passionfruit', 'frutto della passione', 'parchita', 'fruta de la pasion'] },
    { id: 'limon', nombre: 'Limón (jugo)', agua: 92.31, azuc: 2.52, fib: 0.3, prot: 0.35, grasa: 0.24, acid: 5.5, rango: [4.9, 6.0], tipo: 'citrico', jugo: true, sin: ['limon', 'jugo de limon', 'zumo de limon', 'lemon', 'lemon juice', 'limone', 'succo di limone'] },
    { id: 'lima', nombre: 'Lima (jugo)', agua: 90.79, azuc: 1.69, fib: 0.4, prot: 0.42, grasa: 0.07, acid: 6.0, rango: [5.0, 7.0], tipo: 'citrico', jugo: true, sin: ['lima', 'jugo de lima', 'lime', 'lime juice'] },
    { id: 'naranja', nombre: 'Naranja (jugo)', agua: 88.30, azuc: 8.40, fib: 0.2, prot: 0.70, grasa: 0.20, acid: 0.9, rango: [0.6, 1.2], tipo: 'citrico', jugo: true, sin: ['naranja', 'jugo de naranja', 'zumo de naranja', 'orange', 'orange juice', 'arancia', 'succo d arancia'] },
    { id: 'mandarina', nombre: 'Mandarina', agua: 85.17, azuc: 10.58, fib: 1.8, prot: 0.81, grasa: 0.31, acid: 0.9, tipo: 'citrico', sin: ['mandarina', 'mandarinas', 'tangerine', 'mandarin', 'mandarino'] },
    { id: 'pomelo', nombre: 'Pomelo', agua: 88.06, azuc: 6.89, fib: 1.6, prot: 0.77, grasa: 0.14, acid: 1.6, rango: [1.2, 2.0], tipo: 'citrico', sin: ['pomelo', 'toronja', 'grapefruit', 'pompelmo'] },
    { id: 'kiwi', nombre: 'Kiwi', agua: 83.07, azuc: 8.99, fib: 3.0, prot: 1.14, grasa: 0.52, acid: 1.2, rango: [0.9, 1.6], tipo: 'citrico', sin: ['kiwi', 'kiwis'] },
    { id: 'durazno', nombre: 'Durazno', agua: 88.87, azuc: 8.39, fib: 1.5, prot: 0.91, grasa: 0.25, acid: 0.6, tipo: 'malico', sin: ['durazno', 'duraznos', 'melocoton', 'peach', 'peaches', 'pesca', 'pesche'] },
    { id: 'damasco', nombre: 'Damasco', agua: 86.35, azuc: 9.24, fib: 2.0, prot: 1.40, grasa: 0.39, acid: 1.2, tipo: 'malico', sin: ['damasco', 'damascos', 'albaricoque', 'apricot', 'apricots', 'albicocca', 'albicocche'] },
    { id: 'pera', nombre: 'Pera', agua: 83.96, azuc: 9.75, fib: 3.1, prot: 0.36, grasa: 0.14, acid: 0.3, tipo: 'malico', sin: ['pera', 'peras', 'pear', 'pears'] },
    { id: 'manzana', nombre: 'Manzana', agua: 85.56, azuc: 10.39, fib: 2.4, prot: 0.26, grasa: 0.17, acid: 0.5, tipo: 'malico', sin: ['manzana', 'manzanas', 'apple', 'apples', 'mela', 'mele'] },
    { id: 'cereza', nombre: 'Cereza', agua: 82.25, azuc: 12.82, fib: 2.1, prot: 1.06, grasa: 0.20, acid: 0.6, tipo: 'malico', sin: ['cereza', 'cerezas', 'cherry', 'cherries', 'ciliegia', 'ciliegie'] },
    { id: 'guinda', nombre: 'Guinda', agua: 86.13, azuc: 8.49, fib: 1.6, prot: 1.00, grasa: 0.30, acid: 1.6, tipo: 'malico', sin: ['guinda', 'guindas', 'sour cherry', 'amarena', 'amarene', 'visciola'] },
    { id: 'uva', nombre: 'Uva', agua: 80.54, azuc: 15.48, fib: 0.9, prot: 0.72, grasa: 0.16, acid: 0.6, tipo: 'tartarico', sin: ['uva', 'uvas', 'grape', 'grapes'] },
    { id: 'sandia', nombre: 'Sandía', agua: 91.45, azuc: 6.20, fib: 0.4, prot: 0.61, grasa: 0.15, acid: 0.1, tipo: 'malico', sin: ['sandia', 'watermelon', 'anguria', 'cocomero'] },
    { id: 'melon', nombre: 'Melón', agua: 90.15, azuc: 7.86, fib: 0.9, prot: 0.84, grasa: 0.19, acid: 0.1, tipo: 'citrico', sin: ['melon', 'cantaloupe', 'melone'] },
    { id: 'papaya', nombre: 'Papaya', agua: 88.06, azuc: 7.82, fib: 1.7, prot: 0.47, grasa: 0.26, acid: 0.1, tipo: 'citrico', sin: ['papaya', 'papayas'] },
    { id: 'higo', nombre: 'Higo', agua: 79.11, azuc: 16.26, fib: 2.9, prot: 0.75, grasa: 0.30, acid: 0.3, tipo: 'citrico', sin: ['higo', 'higos', 'fig', 'figs', 'fico', 'fichi'] },
    { id: 'chirimoya', nombre: 'Chirimoya', agua: 79.39, azuc: 12.87, fib: 3.0, prot: 1.57, grasa: 0.68, acid: 0.3, tipo: 'malico', sin: ['chirimoya', 'cherimoya'] }
  ];
  var FRUTA_POR_ID = {};
  FRUTAS.forEach(function (f) {
    FRUTA_POR_ID[f.id] = f;
    f.factorAcido = FACT_ACIDO[f.tipo];
    // Ácidos que caben en el balance de masa de la tabla (la tabla los incluye en los hidratos)
    var espacio = 100 - f.agua - f.azuc - f.fib - f.prot - f.grasa - 0.4;
    f.acidTabla = Math.max(0, Math.min(f.acid, espacio));
    var carb = Math.max(f.azuc, 100 - f.agua - f.prot - f.grasa - f.fib - 0.4 - f.acidTabla);
    def('fruta_' + f.id, f.nombre, 'Frutas', {
      agua: f.agua, prot: f.prot, grasa: f.grasa, azuc: f.azuc, carb: carb, fib: f.fib, acid: f.acidTabla,
      pac: f.azuc * K.FRUTA_PAC, pod: f.azuc * K.FRUTA_POD
    }, f.sin);
  });
  def('pulpaFruta', 'Pulpa de fruta', 'Frutas', { agua: 85, prot: 0.6, azuc: 10, carb: 11, fib: 2, acid: 0.8, pac: 18.8, pod: 14.4 },
    ['pulpa de fruta', 'pure de fruta', 'fruta', 'frutas', 'fruit puree', 'fruit', 'fruits', 'purea di frutta', 'frutta', 'polpa di frutta']);
  def('jugoConcentrado', 'Jugo concentrado', 'Frutas', { agua: 35, prot: 2, azuc: 58, carb: 60, acid: 3, pac: 109, pod: 83.5 },
    ['jugo concentrado', 'zumo concentrado', 'concentrado de jugo', 'concentrado de', 'concentrated juice', 'juice concentrate',
      'succo concentrato', 'jugo de fruta concentrado']);

  /* --- Alcohol --- */
  def('alcohol', 'Alcohol etílico', 'Alcohol', { agua: 6, alc: 94, pac: 698, pod: 0 }, ['alcohol', 'alcohol etilico',
    'alcohol potable', 'alcohol neutro', 'etanol', 'ethanol', 'ethyl alcohol', 'alcol', 'alcol etilico', 'spirit',
    'alcohol de origen agricola', 'alcol etilico di origine agricola']);
  def('vino', 'Vino', 'Alcohol', { agua: 87, alc: 9.5, azuc: 0.5, carb: 2, pac: 71, pod: 0.5 },
    ['vino', 'vino blanco', 'vino tinto', 'wine', 'white wine', 'red wine', 'vino bianco', 'vino rosso']);
  def('marsala', 'Vino generoso (marsala, oporto)', 'Alcohol', { agua: 73, alc: 13.65, azuc: 12, pac: 124, pod: 17.3 },
    ['marsala', 'marsala fino', 'vino marsala', 'fine marsala wine', 'marsala wine', 'oporto', 'porto', 'vino de oporto', 'port wine',
      'jerez', 'sherry', 'vino generoso', 'vino licoroso', 'moscatel', 'vino aromatizado', 'vino aromatizado al huevo',
      'egg flavoured wine', 'egg flavored wine', 'vino aromatizzato', 'vino aromatizzato all uovo', 'marsala all uovo']);
  def('licor', 'Licor', 'Alcohol', { agua: 50, alc: 19.5, azuc: 30, pac: 175, pod: 30 },
    ['licor', 'licores', 'liqueur', 'liquore', 'licor de cafe', 'licor de naranja', 'licor de huevo', 'amaretto', 'cointreau',
      'triple sec', 'limoncello', 'kahlua', 'crema de licor', 'cream liqueur', 'crema de whisky']);
  def('destilado', 'Destilado (40°)', 'Alcohol', { agua: 68.8, alc: 31.2, pac: 232, pod: 0 },
    ['ron', 'rum', 'vodka', 'whisky', 'whiskey', 'brandy', 'cognac', 'conac', 'grappa', 'pisco', 'tequila', 'gin', 'ginebra',
      'kirsch', 'aguardiente', 'cachaza', 'cachaca', 'rhum', 'acquavite']);

  /* --- Huevo --- */
  def('yemaPolvo', 'Yema en polvo', 'Huevo', { agua: 3, prot: 33, grasa: 58, azuc: 0.5, carb: 1, pac: 0.5, pod: 0.5 },
    ['yema de huevo en polvo', 'yema en polvo', 'yemas en polvo', 'yema deshidratada', 'powdered egg yolk', 'powdered egg yolks',
      'egg yolk powder', 'dried egg yolk', 'tuorlo d uovo in polvere', 'tuorlo in polvere', 'tuorlo d uovo essiccato']);
  def('yema', 'Yema de huevo', 'Huevo', { agua: 52, prot: 16, grasa: 27, carb: 1 },
    ['yema', 'yemas', 'yema de huevo', 'egg yolk', 'egg yolks', 'tuorlo', 'tuorli', 'tuorlo d uovo']);
  def('huevo', 'Huevo entero', 'Huevo', { agua: 76, prot: 12.6, grasa: 9.5, carb: 0.7 },
    ['huevo', 'huevos', 'huevo entero', 'egg', 'eggs', 'whole egg', 'uovo', 'uova']);
  def('huevoPolvo', 'Huevo en polvo', 'Huevo', { agua: 3, prot: 47, grasa: 41, carb: 3 },
    ['huevo en polvo', 'huevo entero en polvo', 'whole egg powder', 'egg powder', 'uovo intero in polvere']);
  def('clara', 'Clara de huevo', 'Huevo', { agua: 88, prot: 11 }, ['clara', 'claras', 'clara de huevo', 'egg white', 'egg whites', 'albume']);

  /* --- Almidones, harinas y otros --- */
  def('almidon', 'Almidón', 'Almidones y otros', { agua: 12, carb: 88 }, ['almidon', 'almidon modificado', 'almidon de maiz',
    'almidon de papa', 'almidon de tapioca', 'fecula', 'fecula de maiz', 'maicena', 'tapioca', 'starch', 'modified starch',
    'corn starch', 'maize starch', 'potato starch', 'tapioca starch', 'amido', 'amido modificato', 'amido di mais', 'fecola']);
  def('harina', 'Harina', 'Almidones y otros', { agua: 12, prot: 10, grasa: 1.2, azuc: 0.3, carb: 73, fib: 2.7 },
    ['harina', 'harina de trigo', 'harina de arroz', 'wheat flour', 'flour', 'rice flour', 'farina', 'farina di frumento',
      'farina di grano tenero', 'farina di riso']);
  def('galleta', 'Galleta', 'Almidones y otros', { agua: 4, prot: 7, grasa: 18, azuc: 30, carb: 68, fib: 2, pac: 30, pod: 30 },
    ['galleta', 'galletas', 'galleta de chocolate', 'biscuit', 'biscuits', 'cookie', 'cookies', 'biscotto', 'biscotti', 'bizcocho',
      'bizcochuelo', 'vainillas', 'savoiardi', 'crumble']);
  def('caramelo', 'Caramelo (salsa)', 'Almidones y otros', { agua: 20, grasa: 5, prot: 1, azuc: 65, carb: 70, pac: 70, pod: 65 },
    ['caramelo', 'salsa de caramelo', 'caramelo liquido', 'toffee', 'caramello', 'caramel sauce']);
  def('cafe', 'Café soluble', 'Almidones y otros', { agua: 3, prot: 12, grasa: 0.5, carb: 41 },
    ['cafe', 'cafe soluble', 'cafe instantaneo', 'extracto de cafe', 'coffee', 'instant coffee', 'soluble coffee', 'coffee extract',
      'caffe', 'caffe solubile', 'estratto di caffe'], { nota: 'PAC del café soluble no estimado' });
  def('gelatina', 'Gelatina', 'Almidones y otros', { agua: 12, prot: 86 }, ['gelatina', 'gelatina sin sabor', 'gelatin', 'gelatine',
    'gelatina alimentare', 'colla di pesce'], { max: 5 });
  def('agua', 'Agua', 'Almidones y otros', { agua: 100 }, ['agua', 'agua potable', 'water', 'acqua']);
  def('sal', 'Sal', 'Almidones y otros', {}, ['sal', 'sal de mesa', 'sal marina', 'cloruro de sodio', 'salt', 'sea salt',
    'sodium chloride', 'sale', 'sale marino'], { max: 3, aditivo: true });

  /* --- Aditivos --- */
  def('goma', 'Espesante (goma)', 'Aditivos', { agua: 10, fib: 85 }, ['goma guar', 'guar', 'harina de guar', 'harina de semillas de guar',
    'goma garrofin', 'garrofin', 'goma de algarrobo', 'harina de algarrobo', 'harina de semilla de algarrobo', 'goma de semilla de algarrobo',
    'locust bean gum', 'carob bean gum', 'carob gum', 'goma xantana', 'xantana', 'xanthan gum', 'xanthan', 'carragenina', 'carragenano',
    'carrageenan', 'pectina', 'pectin', 'agar', 'agar agar', 'alginato', 'alginato de sodio', 'sodium alginate', 'goma tara', 'tara', 'tara gum',
    'goma gellan', 'gellan', 'goma arabiga', 'goma acacia', 'gum arabic', 'acacia gum', 'celulosa', 'celulosa microcristalina',
    'carboximetilcelulosa', 'carboximetilcelulosa sodica', 'cmc', 'carboxymethyl cellulose', 'carboxymethylcellulose', 'cellulose gum',
    'metilcelulosa', 'hidroxipropilmetilcelulosa', 'farina di semi di carrube', 'farina di semi di guar', 'gomma di guar', 'gomma xantano',
    'carbossimetilcellulosa', 'gomma di tara', 'konjac', 'goma konjac', 'glucomanano', 'espesante', 'espesantes', 'estabilizante',
    'estabilizantes', 'stabilizer', 'stabilizers', 'stabiliser', 'stabilisers', 'thickener', 'thickeners', 'addensante', 'addensanti',
    'stabilizzante', 'stabilizzanti', 'gelificante'], { max: 6, aditivo: true });
  def('sales', 'Sales y fosfatos', 'Aditivos', {}, ['fosfato', 'fosfatos', 'difosfato', 'difosfatos', 'trifosfato', 'polifosfato',
    'citrato de sodio', 'citrato trisodico', 'bicarbonato de sodio', 'bicarbonato', 'sodium citrate', 'diphosphates', 'polyphosphates',
    'disodium phosphate', 'sodium bicarbonate', 'carbonato de calcio', 'calcium carbonate', 'fosfato disodico', 'citrato di sodio'],
    { max: 3, aditivo: true });
  def('acidoCitrico', 'Ácido cítrico', 'Aditivos', { acid: 100, pac: 0, pod: 0 }, ['acido citrico', 'citric acid', 'acido citrico anidro',
    'acido citrico monohidrato', 'acidificante', 'acidulante', 'acidulantes', 'corrector de acidez', 'regulador de acidez',
    'acidity regulator', 'correttore di acidita'], { max: 60, aditivo: true });
  def('acidoMalico', 'Ácido málico', 'Aditivos', { acid: 100, pac: 0, pod: 0 }, ['acido malico', 'malic acid'], { max: 30, aditivo: true });
  def('acidoLactico', 'Ácido láctico', 'Aditivos', { acid: 100, pac: 0, pod: 0 }, ['acido lactico', 'lactic acid', 'acido lattico'], { max: 10, aditivo: true });
  def('acidoTartarico', 'Ácido tartárico', 'Aditivos', { acid: 100, pac: 0, pod: 0 }, ['acido tartarico', 'tartaric acid', 'acido tartarico'], { max: 10, aditivo: true });
  def('conservante', 'Conservante o antioxidante', 'Aditivos', {}, ['sorbato de potasio', 'sorbato potasico', 'potassium sorbate',
    'sorbato di potassio', 'benzoato de sodio', 'sodium benzoate', 'tocoferoles', 'tocopherols', 'vitamina e', 'bha', 'bht', 'sulfitos',
    'sulfito', 'sulfur dioxide', 'sulphur dioxide', 'anhidrido sulfuroso', 'dioxido de azufre', 'metabisulfito de sodio', 'anidride solforosa',
    'solfiti', 'acido ascorbico', 'ascorbic acid', 'vitamina c', 'conservante', 'conservantes', 'preservative', 'antioxidante',
    'antioxidantes', 'antioxidant', 'conservanti', 'antiossidante'], { max: 1, aditivo: true });
  def('colorante', 'Colorante', 'Aditivos', {}, ['colorante', 'colorantes', 'color', 'colour', 'colours', 'colors', 'colorant',
    'color caramelo', 'caramelo natural', 'caramel colour', 'caramel color', 'curcuma', 'curcumina', 'turmeric', 'carmin', 'cochinilla',
    'carmine', 'beta caroteno', 'betacaroteno', 'clorofila', 'clorofilina', 'spirulina', 'extracto de spirulina', 'paprika', 'antocianinas',
    'colorante naturale', 'colore', 'coloranti'], { max: 2, aditivo: true });
  def('aroma', 'Aroma', 'Aditivos', {}, ['aroma', 'aromas', 'aroma natural', 'aromas naturales', 'aroma identico al natural',
    'saborizante', 'saborizantes', 'saborizante natural', 'flavouring', 'flavourings', 'flavoring', 'flavorings', 'natural flavouring',
    'natural flavour', 'natural vanilla flavouring', 'natural vanilla flavour', 'flavour', 'flavor', 'aromi', 'aromi naturali',
    'aroma naturale', 'vainillina', 'vanillin', 'etilvainillina', 'ethyl vanillin', 'extracto de vainilla', 'esencia de vainilla',
    'vainilla', 'vanilla', 'vanilla extract', 'vaniglia', 'estratto di vaniglia', 'bacca di vaniglia', 'aromatizante', 'aromatizantes',
    'especias', 'spices', 'canela', 'cinnamon'], { max: 2, aditivo: true });

  /* --- Códigos E e INS --- */
  var CODIGOS = {
    e322: 'lecitina', e471: 'monodi', e472a: 'esteres', e472b: 'esteres', e472c: 'esteres', e472e: 'esteres', e473: 'esteres',
    e475: 'esteres', e476: 'esteres', e477: 'esteres', e481: 'esteres', e482: 'esteres', e491: 'esteres', e492: 'esteres',
    e433: 'esteres', e435: 'esteres', e420: 'sorbitol', e421: 'glicerol', e422: 'glicerol', e953: 'isomalt', e965: 'maltitol',
    e966: 'lactitol', e967: 'xilitol', e968: 'eritritol', e1200: 'polidextrosa', e330: 'acidoCitrico', e296: 'acidoMalico',
    e270: 'acidoLactico', e334: 'acidoTartarico', e300: 'conservante', e301: 'conservante', e331: 'sales', e332: 'sales', e333: 'sales',
    e339: 'sales', e340: 'sales', e341: 'sales', e450: 'sales', e451: 'sales', e452: 'sales', e500: 'sales', e501: 'sales', e170: 'sales',
    e1520: 'aroma', e1505: 'aroma', e150a: 'colorante', e150b: 'colorante', e150c: 'colorante', e150d: 'colorante'
  };
  function codigoAEntrada(cod) {
    if (CODIGOS[cod]) return CODIGOS[cod];
    var base = cod.replace(/[a-z]$/, '');
    if (CODIGOS[base]) return CODIGOS[base];
    var n = parseInt(base.slice(1), 10);
    if (n >= 100 && n < 200) return 'colorante';
    if (n >= 200 && n < 300) return 'conservante';
    if (n >= 300 && n < 330) return 'conservante';
    if ((n >= 400 && n <= 418) || n === 425 || n === 440 || (n >= 460 && n <= 469)) return 'goma';
    if (n >= 470 && n <= 499) return 'esteres';
    if (n >= 500 && n < 600) return 'sales';
    if (n >= 950 && n <= 969) return 'intenso';
    if (n >= 1400 && n <= 1452) return 'almidon';
    return null;
  }

  /* --- Índice de sinónimos plegados --- */
  var SINONIMOS = [];
  ENTRADAS.forEach(function (e) {
    e.sinonimos.forEach(function (s) {
      var l = limpiar(s);
      SINONIMOS.push({ texto: s, l: l, f: plegar(l), entrada: e.id });
    });
  });

  /* =========================================================
     4. Lector de la lista de ingredientes
     ========================================================= */

  var CORTES = ['puede contener', 'contiene trazas', 'trazas de', 'may contain', 'contains traces', 'can contain', 'puo contenere',
    'elaborado en', 'fabricado en', 'manufactured in', 'produced in', 'alergenos', 'allergens', 'contiene:', 'contains:',
    'informacion nutricional', 'nutrition facts', 'valores nutricionales', 'conservar en', 'store in', 'consumir preferentemente'];

  var CLASES = ['emulsionante', 'emulsionantes', 'emulsificante', 'emulsificantes', 'estabilizante', 'estabilizantes', 'espesante',
    'espesantes', 'colorante', 'colorantes', 'conservante', 'conservantes', 'conservador', 'conservadores', 'acidulante', 'acidulantes',
    'antioxidante', 'antioxidantes', 'gelificante', 'gelificantes', 'edulcorante', 'edulcorantes', 'regulador de acidez',
    'corrector de acidez', 'humectante', 'emulsifier', 'emulsifiers', 'stabiliser', 'stabilisers', 'stabilizer', 'stabilizers',
    'thickener', 'thickeners', 'colour', 'colours', 'color', 'colors', 'preservative', 'preservatives', 'acid', 'acidity regulator',
    'antioxidant', 'antioxidants', 'sweetener', 'sweeteners', 'gelling agent', 'emulsionanti', 'emulsionante', 'stabilizzanti',
    'stabilizzante', 'addensanti', 'addensante', 'coloranti', 'colorante', 'conservanti', 'acidificante', 'acidificanti', 'antiossidanti',
    'edulcoranti', 'agente de carga', 'raising agent', 'leudante', 'stabiliz', 'stabilizz', 'emuls', 'emulsion', 'addens', 'estabiliz', 'espes', 'conserv', 'color', 'antiox'];

  function esClase(t) {
    var l = limpiar(t);
    return CLASES.indexOf(l) >= 0;
  }

  function codigoE(t) {
    var m = normalizar(t).match(/\b(?:e|ins)\s?-?\s?(\d{3,4})\s?([a-i])?(?![a-z0-9])/);
    if (!m) return null;
    return 'e' + m[1] + (m[2] || '');
  }

  function partirNivel0(s) {
    var out = [], prof = 0, buf = '';
    for (var i = 0; i < s.length; i++) {
      var ch = s.charAt(i);
      if (ch === '(' || ch === '[') prof++;
      if (ch === ')' || ch === ']') prof = Math.max(0, prof - 1);
      if ((ch === ',' || ch === ';') && prof === 0) {
        // no partir números decimales tipo 7,4%
        if (ch === ',' && /\d$/.test(buf) && /\d/.test(s.charAt(i + 1) || '')) { buf += ch; continue; }
        out.push(buf); buf = ''; continue;
      }
      buf += ch;
    }
    out.push(buf);
    return out.map(function (x) { return x.trim(); }).filter(function (x) { return x.length; });
  }

  function leerItem(raw, prof) {
    var txt = raw.trim().replace(/^[-•*\s]+/, '').replace(/[.\s]+$/, '');
    var cabeza = '', interiores = [], d = 0, buf = '';
    for (var i = 0; i < txt.length; i++) {
      var ch = txt.charAt(i);
      if (ch === '(' || ch === '[') { if (d === 0) { buf = ''; cabeza += ' '; } else buf += ch; d++; continue; }
      if (ch === ')' || ch === ']') { d = Math.max(0, d - 1); if (d === 0) interiores.push(buf); else buf += ch; continue; }
      if (d === 0) cabeza += ch; else buf += ch;
    }
    if (d > 0 && buf) interiores.push(buf);
    cabeza = cabeza.replace(/\s+/g, ' ').trim();
    var clase = null;
    var mc = cabeza.match(/^([^:]{2,40}):\s*(.*)$/);
    if (mc && esClase(mc[1])) { clase = mc[1].trim(); cabeza = mc[2].trim(); }
    var quid = null, quidMin = false;
    var q = cabeza.match(/(\d+(?:[.,]\d+)?)\s*%/);
    if (q) {
      quid = parseFloat(q[1].replace(',', '.'));
      quidMin = /\bmin/i.test(cabeza);
      cabeza = cabeza.replace(q[0], ' ').replace(/\bm[ií]n(?:imo|\.)?/i, ' ').replace(/\s+/g, ' ').trim();
    }
    var cod = codigoE(cabeza);
    var hijos = [];
    interiores.forEach(function (g) {
      var gq = g.match(/^\s*(?:m[ií]n(?:imo|\.)?\s*)?(\d+(?:[.,]\d+)?)\s*%\s*(?:m[ií]n(?:imo|\.)?)?\s*$/i);
      if (gq) { quid = parseFloat(gq[1].replace(',', '.')); quidMin = /m[ií]n/i.test(g); return; }
      var ge = codigoE(g);
      var resto = normalizar(g).replace(/\b(?:e|ins)\s?-?\s?\d{3,4}\s?[a-i]?(?![a-z0-9])/g, '').replace(/[^a-z]/g, '');
      if (/[,;]/.test(g) && prof < 2) {
        partirNivel0(g).forEach(function (s) {
          var it = leerItem(s, prof + 1);
          if (it.cabeza || it.hijos.length || it.codigo) hijos.push(it);
        });
        return;
      }
      if (ge && resto.length < 3) { if (!cod) cod = ge; return; }
      if (!cabeza || esClase(cabeza)) {
        var it2 = leerItem(g, prof + 1);
        if (it2.cabeza || it2.codigo) hijos.push(it2);
      }
      // si no: es una anotación (alérgeno, origen): se ignora
    });
    if (esClase(cabeza) && hijos.length) cabeza = '';
    return { raw: txt, cabeza: cabeza, clase: clase, quid: quid, quidMin: quidMin, codigo: cod, hijos: hijos };
  }

  function leerLista(texto) {
    var s = normalizar(texto || '');
    var original = texto || '';
    var fin = s.length;
    CORTES.forEach(function (c) { var i = s.indexOf(c); if (i >= 0 && i < fin) fin = i; });
    var t = original.slice(0, fin);
    t = t.replace(/^\s*(ingredientes|ingredients|ingredienti|composicion|composizione|composition)\s*[:.-]?\s*/i, '');
    t = t.replace(/\b(ingredientes|ingredients|ingredienti)\s*:/ig, '');
    return partirNivel0(t).map(function (x) { return leerItem(x, 0); }).filter(function (it) { return it.cabeza || it.hijos.length || it.codigo; });
  }

  /* --- Reconocer un nombre --- */
  function difusoEn(f, minLargo) {
    var palabras = f.split(' ');
    var difuso = null, i, s;
    for (var n = Math.min(6, palabras.length); n >= 1; n--) {
      for (var a = 0; a + n <= palabras.length; a++) {
        var g = palabras.slice(a, a + n).join(' ');
        if (g.length < 4 || g.length < (minLargo || 0)) continue;
        for (i = 0; i < SINONIMOS.length; i++) {
          s = SINONIMOS[i];
          if (Math.abs(s.f.length - g.length) > 3 || s.f.length < 4) continue;
          var d = distancia(g, s.f);
          var p = 1 - d / Math.max(g.length, s.f.length);
          var umbral = g.length >= 9 ? 0.76 : g.length >= 6 ? 0.8 : 0.84;
          if (p >= umbral && (!difuso || p > difuso.puntaje + 1e-9 || (Math.abs(p - difuso.puntaje) < 1e-9 && s.f.length > difuso.largo))) {
            difuso = { entrada: s.entrada, como: 'corregido', puntaje: p, sinonimo: s.texto, largo: s.f.length };
          }
        }
      }
      if (difuso && difuso.puntaje >= 0.9) break;
    }
    return difuso;
  }

  function buscarNombre(texto) {
    var l = limpiar(texto);
    if (!l) return null;
    var f = plegar(l);
    var mejor = null, i, s;
    for (i = 0; i < SINONIMOS.length; i++) { s = SINONIMOS[i]; if (s.l === l) return { entrada: s.entrada, como: 'exacto', puntaje: 1, sinonimo: s.texto }; }
    for (i = 0; i < SINONIMOS.length; i++) { s = SINONIMOS[i]; if (s.f === f) return { entrada: s.entrada, como: 'exacto', puntaje: 1, sinonimo: s.texto }; }
    var ll = ' ' + l + ' ', ff = ' ' + f + ' ';
    for (i = 0; i < SINONIMOS.length; i++) {
      s = SINONIMOS[i];
      var largo = 0;
      if (s.l.length >= 3 && ll.indexOf(' ' + s.l + ' ') >= 0) largo = s.l.length;
      else if (s.f.length >= 3 && ff.indexOf(' ' + s.f + ' ') >= 0) largo = s.f.length;
      if (largo && (!mejor || largo > mejor.largo)) mejor = { entrada: s.entrada, como: 'exacto', puntaje: 0.95, sinonimo: s.texto, largo: largo };
    }
    if (mejor) {
      // ¿la coincidencia exacta cubre casi toda la frase? Si no, puede ser un nombre más largo mal escrito
      if (mejor.largo >= f.length - 3) return mejor;
      var alt = difusoEn(f, mejor.largo + 3);
      if (alt && alt.largo > mejor.largo + 2 && alt.puntaje >= 0.82) return alt;
      return mejor;
    }
    return difusoEn(f, 0);
  }

  function reconocer(item, overrides) {
    var clave = limpiar(item.cabeza || item.raw);
    if (overrides && overrides[clave]) return { entrada: overrides[clave], como: 'manual', puntaje: 1 };
    if (item.codigo) {
      var ec = codigoAEntrada(item.codigo);
      if (ec) {
        var porNombre = item.cabeza && !esClase(item.cabeza) ? buscarNombre(item.cabeza) : null;
        if (porNombre && porNombre.como === 'exacto' && POR_ID[porNombre.entrada].grupo !== 'Aditivos' && ec === 'colorante') {
          return { entrada: ec, como: 'codigo', puntaje: 1, codigo: item.codigo };
        }
        return { entrada: ec, como: 'codigo', puntaje: 1, codigo: item.codigo };
      }
    }
    if (!item.cabeza) return null;
    return buscarNombre(item.cabeza);
  }

  // Aplana la lista en variables, respetando ingredientes compuestos
  function analizarLista(texto, overrides) {
    var items = leerLista(texto);
    var grupos = [];
    items.forEach(function (it) {
      var g = { etiqueta: etiquetaItem(it), quid: it.quid, quidMin: it.quidMin, vars: [] };
      var hijosRec = it.hijos.map(function (h) { return { item: h, rec: reconocer(h, overrides) }; });
      var nRec = hijosRec.filter(function (x) { return x.rec; }).length;
      var recCabeza = it.cabeza ? reconocer(it, overrides) : (it.codigo ? reconocer(it, overrides) : null);
      var usarHijos = it.hijos.length >= 2 ? (nRec >= 1) : (it.hijos.length === 1 && !recCabeza && hijosRec[0].rec);
      if (usarHijos) {
        g.compuesto = true;
        hijosRec.forEach(function (h) {
          g.vars.push({ etiqueta: etiquetaItem(h.item), rec: h.rec, quid: h.item.quid, quidMin: h.item.quidMin, clave: limpiar(h.item.cabeza || h.item.raw) });
        });
      } else {
        g.vars.push({ etiqueta: g.etiqueta, rec: recCabeza, quid: null, clave: limpiar(it.cabeza || it.raw) });
      }
      grupos.push(g);
    });
    return grupos;
  }
  function etiquetaItem(it) {
    var t = it.cabeza || it.clase || it.raw;
    if (it.codigo && t.toLowerCase().indexOf(it.codigo.slice(1)) < 0) t += ' (' + it.codigo.toUpperCase() + ')';
    return t.trim();
  }

  /* =========================================================
     5. Programación lineal (símplex de dos fases)
     ========================================================= */

  function prepararLP(n, filas) {
    var R = filas.map(function (r) {
      var a = r.a.slice(), b = r.b, s = r.s;
      if (b < 0) { a = a.map(function (v) { return -v; }); b = -b; s = s === '<=' ? '>=' : s === '>=' ? '<=' : '='; }
      return { a: a, b: b, s: s };
    });
    var m = R.length, nHol = 0, nArt = 0;
    R.forEach(function (r) { if (r.s === '<=') nHol++; else if (r.s === '>=') { nHol++; nArt++; } else nArt++; });
    var N = n + nHol + nArt;
    var T = [], base = [], esArt = new Uint8Array(N), hi = n, ai = n + nHol, i, j;
    for (i = 0; i < m; i++) {
      var fila = new Float64Array(N + 1);
      for (j = 0; j < n; j++) fila[j] = R[i].a[j] || 0;
      if (R[i].s === '<=') { fila[hi] = 1; base.push(hi); hi++; }
      else if (R[i].s === '>=') { fila[hi] = -1; hi++; fila[ai] = 1; base.push(ai); esArt[ai] = 1; ai++; }
      else { fila[ai] = 1; base.push(ai); esArt[ai] = 1; ai++; }
      fila[N] = R[i].b;
      T.push(fila);
    }
    var st = { T: T, base: base, m: m, N: N, n: n, esArt: esArt };
    var c1 = new Float64Array(N);
    for (j = 0; j < N; j++) if (esArt[j]) c1[j] = 1;
    var todos = new Uint8Array(N); todos.fill(1);
    iterar(st, c1, todos);
    var w = 0;
    for (i = 0; i < m; i++) w += c1[base[i]] * T[i][N];
    if (w > 1e-6) return null;
    for (i = 0; i < m; i++) {
      if (esArt[base[i]]) {
        for (j = 0; j < N; j++) if (!esArt[j] && Math.abs(T[i][j]) > 1e-9) { pivotear(st, i, j); break; }
      }
    }
    return st;
  }
  function pivotear(st, r, col) {
    var T = st.T, N = st.N, pr = T[r], pv = pr[col], i, j;
    for (j = 0; j <= N; j++) pr[j] /= pv;
    for (i = 0; i < st.m; i++) {
      if (i === r) continue;
      var f = T[i][col];
      if (Math.abs(f) > 1e-12) { var ri = T[i]; for (j = 0; j <= N; j++) ri[j] -= f * pr[j]; }
    }
    st.base[r] = col;
  }
  function iterar(st, costo, permitido) {
    var T = st.T, m = st.m, N = st.N, base = st.base;
    for (var it = 0; it < 4000; it++) {
      var entra = -1, j, i;
      for (j = 0; j < N; j++) {
        if (!permitido[j]) continue;
        var rc = costo[j];
        for (i = 0; i < m; i++) { var cb = costo[base[i]]; if (cb) rc -= cb * T[i][j]; }
        if (rc < -1e-9) { entra = j; break; }
      }
      if (entra < 0) return 'optimo';
      var sale = -1, mejor = Infinity;
      for (i = 0; i < m; i++) {
        var v = T[i][entra];
        if (v > 1e-9) {
          var razon = T[i][N] / v;
          if (razon < mejor - 1e-12 || (Math.abs(razon - mejor) <= 1e-12 && base[i] < base[sale])) { mejor = razon; sale = i; }
        }
      }
      if (sale < 0) return 'no acotado';
      pivotear(st, sale, entra);
    }
    return 'limite';
  }
  function optimizar(st0, c, maximizar) {
    var st = { T: st0.T.map(function (f) { return Float64Array.from(f); }), base: st0.base.slice(), m: st0.m, N: st0.N, n: st0.n, esArt: st0.esArt };
    var N = st.N, n = st.n, j, i;
    var costo = new Float64Array(N);
    for (j = 0; j < n; j++) costo[j] = maximizar ? -c[j] : c[j];
    var perm = new Uint8Array(N);
    for (j = 0; j < N; j++) perm[j] = st.esArt[j] ? 0 : 1;
    var r = iterar(st, costo, perm);
    if (r !== 'optimo') return null;
    var x = new Array(n).fill(0);
    for (i = 0; i < st.m; i++) if (st.base[i] < n) x[st.base[i]] = st.T[i][N];
    var val = 0;
    for (j = 0; j < n; j++) val += c[j] * x[j];
    return { x: x, val: val };
  }

  /* =========================================================
     6. Reconstrucción de la receta (pastas, bases, mezclas)
     ========================================================= */

  var NIVELES = [
    { nombre: 'estricto', tol: 1, ordenAditivos: 0, sinOrdenAditivos: false, energia: true, humedad: true, orden: true },
    { nombre: 'aditivos flexibles', tol: 1.5, ordenAditivos: 3, sinOrdenAditivos: false, energia: true, humedad: true, orden: true },
    { nombre: 'tolerancias amplias', tol: 2.2, ordenAditivos: 0, sinOrdenAditivos: true, energia: true, humedad: true, orden: true },
    { nombre: 'sin calorías ni humedad', tol: 2.5, ordenAditivos: 0, sinOrdenAditivos: true, energia: false, humedad: false, orden: true },
    { nombre: 'sin orden', tol: 3, ordenAditivos: 0, sinOrdenAditivos: true, energia: false, humedad: false, orden: false }
  ];

  function reconstruir(grupos, et) {
    // Variables
    var base = [];
    grupos.forEach(function (g, gi) {
      g.vars.forEach(function (v, vi) {
        var e = v.rec ? POR_ID[v.rec.entrada] : null;
        base.push({ g: gi, vi: vi, e: e, etiqueta: v.etiqueta, quid: v.quid, quidMin: v.quidMin });
      });
    });
    if (!base.length) return { ok: false, motivo: 'vacia' };

    // Ingredientes ambiguos: se prueban todas las combinaciones de variantes hasta un tope;
    // los que no caben en el tope se modelan como una mezcla libre de sus variantes (nunca se fijan a una sola)
    var ambiguos = [], divididos = {};
    base.forEach(function (v) {
      if (v.e && v.e.variantes && ambiguos.every(function (a) { return a.id !== v.e.id; })) ambiguos.push({ id: v.e.id, k: v.e.variantes.length });
    });
    var combos = [{}], enumerados = [];
    ambiguos.forEach(function (a) {
      if (combos.length * a.k <= 18) {
        var nuevos = [];
        combos.forEach(function (cb) { for (var k = 0; k < a.k; k++) { var o = Object.assign({}, cb); o[a.id] = k; nuevos.push(o); } });
        combos = nuevos; enumerados.push(a);
      } else divididos[a.id] = true;
    });
    ambiguos = enumerados;
    var vars = [];
    base.forEach(function (v, i) {
      if (v.e && divididos[v.e.id]) {
        v.e.variantes.forEach(function (va, k) { vars.push(Object.assign({}, v, { orig: i, variante: k })); });
      } else vars.push(Object.assign({}, v, { orig: i }));
    });
    var n = vars.length;

    function comp(v, combo) {
      if (!v.e) return null;
      if (v.variante !== undefined) return v.e.variantes[v.variante].c;
      if (v.e.variantes) return v.e.variantes[combo[v.e.id] || 0].c;
      return v.e.c;
    }

    for (var ni = 0; ni < NIVELES.length; ni++) {
      var nivel = NIVELES[ni];
      var factibles = [];
      combos.forEach(function (combo) {
        var filas = construirFilas(vars, grupos, et, nivel, combo, comp);
        var st = prepararLP(n, filas);
        if (st) factibles.push({ combo: combo, st: st });
      });
      if (!factibles.length) continue;

      var obj = function (campo) {
        return vars.map(function (v) { var c = null; return 0; });
      };
      var res = { pac: { min: Infinity, max: -Infinity }, pod: { min: Infinity, max: -Infinity }, lac: { min: Infinity, max: -Infinity },
        alc: { min: Infinity, max: -Infinity }, agua: { min: Infinity, max: -Infinity }, grupos: grupos.map(function () { return { min: Infinity, max: -Infinity }; }) };
      var muestras = [];
      factibles.forEach(function (fz) {
        var cv = function (campo) { return vars.map(function (v) { var c = comp(v, fz.combo); return c ? c[campo] / 100 : 0; }); };
        ['pac', 'pod', 'lac', 'alc', 'agua'].forEach(function (campo) {
          var c = cv(campo);
          var lo = optimizar(fz.st, c, false), hi = optimizar(fz.st, c, true);
          if (lo) { res[campo].min = Math.min(res[campo].min, lo.val); if (campo === 'pac') muestras.push({ x: lo.x, combo: fz.combo }); }
          if (hi) { res[campo].max = Math.max(res[campo].max, hi.val); if (campo === 'pac') muestras.push({ x: hi.x, combo: fz.combo }); }
        });
        grupos.forEach(function (g, gi) {
          var c = vars.map(function (v) { return v.g === gi ? 1 : 0; });
          var lo = optimizar(fz.st, c, false), hi = optimizar(fz.st, c, true);
          if (lo) res.grupos[gi].min = Math.min(res.grupos[gi].min, lo.val);
          if (hi) res.grupos[gi].max = Math.max(res.grupos[gi].max, hi.val);
        });
      });
      // Solución central: una receta factible con el PAC al medio del rango
      var pacMid = (res.pac.min + res.pac.max) / 2;
      var central = null;
      for (var fi = 0; fi < factibles.length && !central; fi++) {
        var fz = factibles[fi];
        var cpac = vars.map(function (v) { var c = comp(v, fz.combo); return c ? c.pac / 100 : 0; });
        var filas2 = construirFilas(vars, grupos, et, nivel, fz.combo, comp).concat([{ a: cpac, s: '=', b: pacMid }]);
        var st2 = prepararLP(n, filas2);
        if (st2) {
          // centrar también los grupos: tomar el promedio de minimizar y maximizar la suma ponderada por posición
          var cpos = vars.map(function (v) { return v.g; });
          var a1 = optimizar(st2, cpos, false), a2 = optimizar(st2, cpos, true);
          if (a1 && a2) central = { x: a1.x.map(function (x, i) { return (x + a2.x[i]) / 2; }), combo: fz.combo };
        }
      }
      if (!central && muestras.length) central = { x: muestras[0].x, combo: muestras[0].combo };

      var variantesOk = {};
      ambiguos.forEach(function (a) {
        var vistos = {};
        factibles.forEach(function (fz) { vistos[fz.combo[a.id] || 0] = true; });
        variantesOk[a.id] = Object.keys(vistos).map(function (k) { return POR_ID[a.id].variantes[+k].tag; });
      });

      return { ok: true, nivel: ni, nombreNivel: nivel.nombre, res: res, central: central, vars: vars, comp: comp,
        variantesOk: variantesOk, ambiguos: ambiguos, combosProbados: combos.length, combosFactibles: factibles.length };
    }
    return { ok: false, motivo: 'infactible', vars: vars };
  }

  function construirFilas(vars, grupos, et, nivel, combo, comp) {
    var n = vars.length, filas = [];
    var fila = function (fn) { return vars.map(fn); };
    var C = vars.map(function (v) { return comp(v, combo); });
    var col = function (campo) { return fila(function (v, i) { return C[i] ? C[i][campo] / 100 : 0; }); };
    var banda = function (a, val, tol) { filas.push({ a: a, s: '<=', b: val + tol }); filas.push({ a: a.map(function (x) { return x; }), s: '>=', b: Math.max(0, val - tol) }); };
    var t = nivel.tol;

    filas.push({ a: fila(function () { return 1; }), s: '=', b: 100 });
    // unidades = ingredientes originales (un ingrediente ambiguo dividido suma sus variantes)
    var unidades = [];
    vars.forEach(function (v, i) {
      var u = unidades.length ? unidades[unidades.length - 1] : null;
      if (u && u.orig === v.orig) u.idx.push(i); else unidades.push({ orig: v.orig, g: v.g, idx: [i], v: v });
    });
    var filaU = function (u) { return fila(function (w, j) { return u.idx.indexOf(j) >= 0 ? 1 : 0; }); };
    unidades.forEach(function (u) {
      var v = u.v;
      var lim = v.e && v.e.max ? v.e.max : null;
      if (lim !== null) filas.push({ a: filaU(u), s: '<=', b: lim });
      if (v.quid !== null && v.quid !== undefined) {
        if (v.quidMin) filas.push({ a: filaU(u), s: '>=', b: v.quid }); else banda(filaU(u), v.quid, 0.6 * t);
      }
    });
    // QUID de grupo
    grupos.forEach(function (g, gi) {
      if (g.quid === null || g.quid === undefined) return;
      var a = fila(function (v) { return v.g === gi ? 1 : 0; });
      if (g.quidMin) filas.push({ a: a, s: '>=', b: g.quid }); else banda(a, g.quid, 0.6 * t);
    });
    // Orden de la lista (de mayor a menor)
    if (nivel.orden) {
      var esAditivoGrupo = grupos.map(function (g, gi) {
        return vars.filter(function (v) { return v.g === gi; }).every(function (v) { return v.e && v.e.aditivo; });
      });
      for (var gi = 0; gi + 1 < grupos.length; gi++) {
        var aditivo = esAditivoGrupo[gi + 1] || esAditivoGrupo[gi];
        if (aditivo && nivel.sinOrdenAditivos) continue;
        var holgura = aditivo ? nivel.ordenAditivos : 0;
        var a = fila(function (v) { return v.g === gi ? 1 : v.g === gi + 1 ? -1 : 0; });
        filas.push({ a: a, s: '>=', b: -holgura });
      }
      // Orden dentro de los compuestos
      unidades.forEach(function (u, k) {
        var sig = unidades[k + 1];
        if (sig && sig.g === u.g) {
          var adit = sig.v.e && sig.v.e.aditivo;
          if (adit && nivel.sinOrdenAditivos) return;
          var a2 = fila(function (w, j) { return u.idx.indexOf(j) >= 0 ? 1 : sig.idx.indexOf(j) >= 0 ? -1 : 0; });
          filas.push({ a: a2, s: '>=', b: adit ? -nivel.ordenAditivos : 0 });
        }
      });
    }
    // Etiqueta
    if (et.grasa !== null) banda(col('grasa'), et.grasa, (0.6 + 0.06 * et.grasa) * t);
    if (et.proteina !== null) banda(col('prot'), et.proteina, (0.4 + 0.08 * et.proteina) * t);
    if (et.azucares !== null) banda(col('azuc'), et.azucares, (1 + 0.05 * et.azucares) * t);
    if (et.hidratos !== null) banda(col('carb'), et.hidratosDisp, (1.5 + 0.05 * et.hidratosDisp) * t);
    if (et.fibra !== null && et.fibra > 0) filas.push({ a: col('fib'), s: '<=', b: et.fibra * 1.6 + 1.5 * t });
    if (et.energia !== null && nivel.energia) banda(col('kcal'), et.energia, (5 + 0.07 * et.energia) * t);
    if (et.humedad !== null && nivel.humedad) {
      filas.push({ a: col('agua'), s: '<=', b: et.humedad + 0.5 * t });
      filas.push({ a: col('agua'), s: '>=', b: Math.max(0, et.humedad - 4 * t) });
    }
    if (et.alcoholVol !== null && et.alcoholVol > 0) {
      var conv = et.alcoholVol * K.DENS_ALCOHOL;
      filas.push({ a: col('alc'), s: '>=', b: conv * 0.95 });
      filas.push({ a: col('alc'), s: '<=', b: conv * 1.25 });
    }
    return filas;
  }

  /* =========================================================
     7. Cálculo por categoría
     ========================================================= */

  function rango(c, min, max) { return { c: c, min: min === undefined ? c : min, max: max === undefined ? c : max }; }
  function nuevo() { return { ok: false, faltan: [], errores: [], avisos: [], pasos: [], comp: [], receta: null, chips: null }; }
  function f1(v) { return fmt(v, 1); }
  function fmt(v, d) {
    if (d === undefined) d = 1;
    if (Math.abs(v) < Math.pow(10, -d) / 2) v = 0;
    return v.toLocaleString('es-CL', { minimumFractionDigits: d, maximumFractionDigits: d }).replace(/^-/, '−');
  }
  function fA(v) { return Math.abs(v) < 9.95 ? fmt(v, 1) : fmt(v, 0); }
  function requerir(r, e, campos) {
    campos.forEach(function (k) { if (e[k] === null || e[k] === undefined) r.faltan.push({ campo: k }); });
  }
  function validarNumeros(r, e, campos) {
    campos.forEach(function (k) {
      if (typeof e[k] === 'number' && isNaN(e[k])) r.errores.push({ campo: k, texto: 'Escribe solo el número, por ejemplo 4,6.' });
      else if (typeof e[k] === 'number' && e[k] < 0) r.errores.push({ campo: k, texto: 'No puede ser negativo.' });
    });
  }
  function porCien(e) {
    var f = e.unidad === 'ml' && e.densidad > 0 ? 100 / e.densidad : 1;
    var o = {};
    ['energia', 'proteina', 'grasa', 'hidratos', 'azucares', 'fibra'].forEach(function (k) { o[k] = e[k] === null ? null : e[k] * f; });
    if (o.fibra !== null && !(o.fibra >= 0)) o.fibra = null;
    o.f = f;
    o.hidratosDisp = o.hidratos === null ? null : (e.origen === 'eeuu' && o.fibra !== null ? o.hidratos - o.fibra : o.hidratos);
    return o;
  }
  function chequeoEnergia(r, E, Ecalc, extra) {
    if (E === null) { r.avisos.push({ tipo: 'info', texto: 'Sin la energía no podemos verificar que la etiqueta cuadre.' }); return; }
    var dif = E - Ecalc, tol = Math.max(5, 0.1 * E);
    if (Math.abs(dif) <= tol) r.avisos.push({ tipo: 'ok', texto: 'Las calorías cuadran: la etiqueta dice ' + fmt(E, 0) + ' kcal y la cuenta da ' + fmt(Ecalc, 0) + '.' });
    else if (dif > 0) r.avisos.push({ tipo: 'alerta', texto: 'Faltan ' + fmt(dif, 0) + ' kcal en la cuenta. ' + (extra || 'Puede haber alcohol o un ingrediente que la etiqueta no separa.') });
    else r.avisos.push({ tipo: 'alerta', texto: 'Sobran ' + fmt(-dif, 0) + ' kcal en la cuenta. Revisa que los valores sean por 100 g y no por porción.' });
  }

  /* --- Lácteos --- */
  function calcLacteos(e, overrides) {
    var r = nuevo();
    validarNumeros(r, e, ['energia', 'proteina', 'grasa', 'hidratos', 'azucares', 'densidad', 'fibra']);
    if (r.errores.length) return r;
    requerir(r, e, ['proteina', 'grasa', 'azucares']);
    if (e.unidad === 'ml' && !(e.densidad > 0)) r.faltan.push({ campo: 'densidad' });
    if (r.faltan.length) return r;
    var p = porCien(e), P = p.proteina, G = p.grasa, A = p.azucares, H = p.hidratos === null ? A : p.hidratosDisp;
    if (A > H + 0.5) { r.errores.push({ campo: 'azucares', texto: 'Los azúcares no pueden ser más que los hidratos.' }); return r; }
    var lista = e.ingredientes ? analizarLista(e.ingredientes, overrides) : [];
    r.chips = chipsDe(lista);
    var ids = idsDe(lista);
    var sub = e.subLac === 'con' ? 'con' : 'sin'; // los deslactosados se tratan igual que un lácteo normal
    var lac, pod, pac, origen = 'deducido';
    if (e.unidad === 'ml') r.pasos.push('Pasamos todo a 100 g: esos 100 ml pesan ' + fmt(e.densidad, 0) + ' g.');
    r.pasos.push('Copiamos la grasa (' + f1(G) + ' g) y las proteínas (' + f1(P) + ' g) de la etiqueta.');
    if (sub === 'sin') {
      lac = rango(A); pod = rango(A * K.POD_LACTOSA); pac = rango(A);
      r.pasos.push('En un lácteo sin azúcar agregada, todo el azúcar es lactosa: ' + f1(A) + ' g. La lactosa endulza 16 y anticongela 100: POD = ' + fA(pod.c) + ', PAC = ' + fA(pac.c) + '.');
      if (ids.some(function (id) { return POR_ID[id].grupo === 'Azúcares y edulcorantes' && id !== 'lactosa'; })) {
        r.avisos.push({ tipo: 'alerta', texto: 'La lista trae azúcar agregada: no todo su azúcar es lactosa.', accion: { campo: 'subLac', valor: 'con', texto: 'Cambiar a lácteo con azúcar' } });
      }
    } else if (sub === 'sinlac') {
      lac = rango(0); pod = rango(A * K.POD_LACTOSA); pac = rango(A * 1.9); origen = 'deducido';
      r.pasos.push('Sin lactosa, el azúcar de la leche viene partido en glucosa y galactosa, moléculas de la mitad del tamaño: PAC = ' + f1(A) + ' × 1,9 = ' + fA(pac.c) + '. El POD se mantiene con el criterio de la lactosa: ' + fA(pod.c) + '.');
    } else {
      var lc = Math.min(P * K.LACTOSA_PROT.c, A), lmin = Math.min(P * K.LACTOSA_PROT.min, A), lmax = Math.min(P * K.LACTOSA_PROT.max, A);
      var glucosa = ids.some(function (id) { return ['glucosaLiquida', 'glucosaDeshidratada', 'glucosaPolvo'].indexOf(id) >= 0; });
      var mono = ids.some(function (id) { return ['dextrosa', 'fructosa', 'jmaf', 'invertido', 'miel'].indexOf(id) >= 0; });
      lac = rango(lc, lmin, lmax);
      r.pasos.push('La lactosa sale de la proteína: la leche trae cerca de 1,5 g de lactosa por gramo de proteína. ' + f1(P) + ' × 1,5 = ' + f1(lc) + ' g de lactosa; el resto, ' + f1(A - lc) + ' g, es azúcar agregada.');
      if (glucosa && !mono) {
        // Convención del video: 85 % sacarosa y 15 % jarabe de glucosa DE 40 (POD 32, PAC 61) en el azúcar agregada
        var gq = 0.15, gmin = 0.05, gmax = 0.25, podG = 0.32, pacG = 0.61;
        var podDe = function (l, g) { return l * K.POD_LACTOSA + (A - l) * (1 - g) + (A - l) * g * podG; };
        var pacDe = function (l, g) { return l + (A - l) * (1 - g) + (A - l) * g * pacG; };
        pod = rango(podDe(lc, gq), podDe(lmax, gmax), podDe(lmin, gmin));
        pac = rango(pacDe(lc, gq), pacDe(lmax, gmax), pacDe(lmin, gmin));
        r.pasos.push('Lleva jarabe de glucosa: suponemos el azúcar agregada como 85 % sacarosa y 15 % glucosa. ' + f1(A - lc) + ' × 0,85 = ' + f1((A - lc) * 0.85) + ' g de sacarosa y ' + f1(A - lc) + ' × 0,15 = ' + f1((A - lc) * 0.15) + ' g de glucosa, que endulza 32 y anticongela 61.');
        r.pasos.push('POD = ' + f1(lc) + ' × 0,16 + ' + f1((A - lc) * 0.85) + ' + ' + f1((A - lc) * 0.15) + ' × 0,32 = ' + fA(pod.c) + '. PAC = ' + f1(lc) + ' + ' + f1((A - lc) * 0.85) + ' + ' + f1((A - lc) * 0.15) + ' × 0,61 = ' + fA(pac.c) + '.');
      } else {
        var mc = mono ? 0.1 : 0, mmax = mono ? 0.25 : 0.05;
        pod = rango(lc * 0.16 + (A - lc) * (1 - mc) + (A - lc) * mc * 0.95, lmax * 0.16 + (A - lmax) * (1 - mmax) + (A - lmax) * mmax * 0.7, lmin * 0.16 + (A - lmin) * (1 - mmax) + (A - lmin) * mmax * 1.2);
        pac = rango(A + (A - lc) * mc * 0.9, A, A + (A - lmin) * mmax * 0.9);
      }
      origen = 'supuesto';
      if (ids.indexOf('suero') >= 0 || ids.indexOf('protSuero') >= 0) r.avisos.push({ tipo: 'alerta', texto: 'Lleva suero, que trae más lactosa por gramo de proteína que la leche: la lactosa estimada puede quedar corta.' });
    }
    var ST = G + P + H;
    r.pasos.push('Sólidos totales: grasa + proteínas + hidratos = ' + f1(ST) + ' g.');
    chequeoEnergia(r, p.energia, 4 * P + 4 * H + 9 * G);
    r.ok = true;
    r.ficha = { pod: pod, pac: pac, grasa: G, st: ST, lac: lac, prot: P };
    r.origen = { pod: origen, pac: origen, grasa: 'etiqueta', st: 'deducido', lac: sub === 'con' ? 'supuesto' : 'deducido', prot: 'etiqueta' };
    r.comp = [{ nombre: sub === 'sinlac' ? 'Glucosa y galactosa' : 'Lactosa', v: sub === 'con' ? lac.c : (sub === 'sinlac' ? pac.c : pac.c), clase: 'seg-lactosa' }];
    if (sub === 'con') r.comp.push({ nombre: 'Azúcar agregada', v: pac.c - lac.c, clase: 'seg-azucar' });
    r.azucares = A;
    r.frase = sub === 'sin' ? 'Su PAC viene de la lactosa, que anticongela igual que el azúcar común pero endulza seis veces menos.' : null;
    return r;
  }

  /* --- Fruta --- */
  function calcFruta(e) {
    var r = nuevo();
    var f = FRUTA_POR_ID[e.fruta];
    if (!f) { r.faltan.push({ campo: 'fruta' }); return r; }
    validarNumeros(r, e, ['brix', 'acidez']);
    if (r.errores.length) return r;
    var metodo = e.metFruta || 'tabla';
    var acidOrigen = 'tabla', acid, acidMin, acidMax;
    if (metodo === 'tabla') {
      acid = f.acidTabla; acidMin = acid; acidMax = acid;
      var A = f.azuc, ST = 100 - f.agua;
      var pod = A * K.FRUTA_POD, pacAz = A * K.FRUTA_PAC;
      r.pasos.push('Tomamos la composición de la tabla USDA para ' + f.nombre.toLowerCase() + ': ' + f1(A) + ' g de azúcares, ' + f1(f.agua) + ' g de agua.');
      r.pasos.push('Con la convención de la escuela, POD = ' + f1(A) + ' × 1,44 = ' + fA(pod) + ' y el PAC de los azúcares = ' + f1(A) + ' × 1,88 = ' + fA(pacAz) + '.');
      r.ok = true;
      r.ficha = { pod: rango(pod), pac: rango(pacAz), grasa: f.grasa, st: ST, lac: rango(0), prot: f.prot };
      r.origen = { pod: 'tabla', pac: 'tabla', grasa: 'tabla', st: 'tabla', lac: 'deducido', prot: 'tabla' };
      r.comp = [{ nombre: 'Azúcares de la fruta', v: pacAz, clase: 'seg-azucar' }];
      r.azucares = A;
      return r;
    }
    // Refractómetro
    if (e.brix === null) { r.faltan.push({ campo: 'brix' }); return r; }
    if (e.brix > 70) { r.errores.push({ campo: 'brix', texto: 'Un jugo o pulpa de fruta no pasa de 30 a 35 °Brix. Revisa la lectura.' }); return r; }
    if (e.acidez !== null) { acid = e.acidez; acidMin = acid; acidMax = acid; acidOrigen = 'medido'; }
    else { acid = f.acid; acidMin = f.rango ? f.rango[0] : f.acid * 0.8; acidMax = f.rango ? f.rango[1] : f.acid * 1.2; }
    var brix = e.brix;
    var az = Math.max(0, brix - acid), azMin = Math.max(0, brix - acidMax), azMax = Math.max(0, brix - acidMin);
    var pulpa = (e.formaFruta || (f.jugo ? 'jugo' : 'pulpa')) === 'pulpa';
    var insol = pulpa ? f.fib + f.prot * 0.5 + f.grasa : 0;
    var ST2 = brix + insol;
    var podC = az * K.FRUTA_POD;
    var pacC = az * K.FRUTA_PAC;
    var pacMin = azMin * K.FRUTA_PAC, pacMax = azMax * K.FRUTA_PAC;
    r.pasos.push('El refractómetro mide todo lo disuelto: azúcares y ácidos. Leíste ' + f1(brix) + ' °Brix.');
    r.pasos.push((acidOrigen === 'medido' ? 'Tu acidez medida es ' : 'La acidez típica de ' + f.nombre.toLowerCase() + ' es ') + f1(acid) + ' g por 100 g, así que los azúcares son ' + f1(brix) + ' − ' + f1(acid) + ' = ' + f1(az) + ' g.');
    r.pasos.push('Con la convención de la escuela, POD = ' + f1(az) + ' × 1,44 = ' + fA(podC) + ' y PAC = ' + f1(az) + ' × 1,88 = ' + fA(pacC) + '. Los ácidos cuentan como sólidos, pero no como dulzor ni como PAC.');
    r.pasos.push('Sólidos totales: ' + (pulpa ? f1(brix) + ' °Brix + ' + f1(insol) + ' g de pulpa que el refractómetro no ve (fibra) = ' + f1(ST2) + ' g.' : 'en un jugo colado son los mismos ' + f1(brix) + ' °Brix.'));
    var esperado = f.azuc + f.acid;
    var dif = (brix - esperado) / esperado;
    if (Math.abs(dif) >= 0.1) {
      r.avisos.push({ tipo: dif > 0 ? 'ok' : 'alerta', texto: 'Tu fruta tiene ' + fmt(Math.abs(dif) * 100, 0) + '% ' + (dif > 0 ? 'más' : 'menos') + ' sólidos disueltos que el promedio de tabla (~' + f1(esperado) + ' °Brix). Con la tabla te habrías equivocado en esa proporción.' });
    } else {
      r.avisos.push({ tipo: 'info', texto: 'Tu lectura está cerca del promedio de tabla (~' + f1(esperado) + ' °Brix).' });
    }
    if (acidOrigen !== 'medido' && f.rango && f.rango[1] - f.rango[0] >= 1) {
      r.avisos.push({ tipo: 'info', texto: 'La acidez de ' + f.nombre.toLowerCase() + ' varía bastante (' + f1(f.rango[0]) + ' a ' + f1(f.rango[1]) + '%). Si la mides, el POD y el PAC salen más precisos.' });
    }
    r.ok = true;
    r.ficha = { pod: rango(podC, azMin * K.FRUTA_POD, azMax * K.FRUTA_POD), pac: rango(pacC, pacMin, pacMax), grasa: f.grasa, st: ST2, lac: rango(0), prot: f.prot };
    var origenAz = acidOrigen === 'medido' ? 'medido' : 'supuesto';
    r.origen = { pod: origenAz, pac: origenAz, grasa: 'tabla', st: 'medido', lac: 'deducido', prot: 'tabla' };
    r.comp = [{ nombre: 'Azúcares de la fruta', v: pacC, clase: 'seg-azucar' }];
    r.azucares = az;
    return r;
  }

  /* --- Frutos secos --- */
  function calcFrutos(e, overrides) {
    var r = nuevo();
    var n = FRUTOS_SECOS.filter(function (x) { return x.id === e.fruto; })[0];
    if (!n) { r.faltan.push({ campo: 'fruto' }); return r; }
    var origenPAC = n.escuela ? 'escuela' : 'deducido';
    var fuentePAC = n.escuela ? 'valor fijo de la escuela' : '1,4 × la grasa del fruto (' + f1(n.grasa) + ' g), el mismo coeficiente de la escuela';
    if ((e.presNuez || 'pura') === 'pura') {
      r.pasos.push('Composición de la pasta pura de ' + n.nombre.toLowerCase() + ' según USDA: ' + f1(n.grasa) + ' g de grasa, ' + f1(n.prot) + ' g de proteína, ' + f1(n.azuc) + ' g de azúcares propios.');
      r.pasos.push('PAC = ' + fmt(n.pac, 0) + ', ' + fuentePAC + '. Es negativo porque el fruto seco endurece el helado.');
      r.ok = true;
      r.ficha = { pod: rango(n.azuc), pac: rango(n.pac), grasa: n.grasa, st: 100 - n.agua, lac: rango(0), prot: n.prot };
      r.origen = { pod: 'tabla', pac: origenPAC, grasa: 'tabla', st: 'tabla', lac: 'deducido', prot: 'tabla' };
      r.comp = [{ nombre: n.nombre, v: n.pac, clase: 'seg-negativo' }];
      r.azucares = n.azuc;
      return r;
    }
    validarNumeros(r, e, ['energia', 'proteina', 'grasa', 'hidratos', 'azucares', 'fibra', 'quidNuez', 'humedad']);
    if (r.errores.length) return r;
    requerir(r, e, ['proteina', 'grasa', 'azucares']);
    if (r.faltan.length) return r;
    var p = porCien(e), P = p.proteina, G = p.grasa, A = p.azucares;
    var lista = e.ingredientes ? analizarLista(e.ingredientes, overrides) : [];
    r.chips = chipsDe(lista);
    var ids = idsDe(lista);
    var conLeche = ids.some(function (id) { return POR_ID[id].grupo === 'Lácteos'; });
    var quid = e.quidNuez;
    if (quid === null) {
      lista.forEach(function (g) { g.vars.forEach(function (v) { if (v.rec && v.rec.entrada === n.id) { if (v.quid !== null && v.quid !== undefined) quid = v.quid; else if (g.quid !== null && g.quid !== undefined) quid = g.quid; } }); });
    }
    var x, xMin, xMax, via;
    if (quid !== null) { x = quid / 100; xMin = x; xMax = x; via = 'declarado'; }
    else if (conLeche) {
      r.faltan.push({ campo: 'quidNuez', nota: 'La pasta lleva lácteos, así que la proteína ya no sirve para saber cuánto ' + n.nombre.toLowerCase() + ' trae.' });
      return r;
    } else {
      x = Math.min(1, P / n.prot); xMin = Math.min(1, x * 0.9); xMax = Math.min(1, x * 1.1); via = 'proteina';
    }
    var grasaFruto = x * n.grasa, aceite = G - grasaFruto;
    var azPropio = x * n.azuc, azAgregado = Math.max(0, A - azPropio);
    var mono = ids.some(function (id) { return ['glucosaLiquida', 'glucosaDeshidratada', 'glucosaPolvo', 'dextrosa', 'fructosa', 'jmaf', 'invertido', 'miel'].indexOf(id) >= 0; });
    var facAz = mono ? 1.25 : 1, facAzMax = mono ? 1.5 : 1.05;
    var pacN = n.pac * x, pacNmin = n.pac * xMax, pacNmax = n.pac * xMin;
    var pacAz = azAgregado * facAz;
    var pac = rango(pacN + pacAz, pacNmin + azAgregado, pacNmax + azAgregado * facAzMax);
    var lac = rango(0);
    if (conLeche) { var lm = Math.min(P * 0.5, azAgregado); lac = rango(lm / 2, 0, lm); }
    r.pasos.push(via === 'declarado'
      ? 'La etiqueta declara ' + fmt(x * 100, 0) + '% de ' + n.nombre.toLowerCase() + '.'
      : 'Usamos la proteína como testigo: el azúcar y el aceite no tienen. ' + f1(P) + ' g ÷ ' + f1(n.prot) + ' g de proteína del ' + n.nombre.toLowerCase() + ' = ' + fmt(x * 100, 0) + '% de fruto seco.');
    r.pasos.push('El fruto seco aporta ' + f1(grasaFruto) + ' g de grasa' + (aceite > 1 ? '; los otros ' + f1(aceite) + ' g son aceite agregado, que cuenta como grasa pero no resta PAC.' : '.'));
    r.pasos.push('PAC del fruto seco: ' + fmt(n.pac, 0) + ' × ' + fmt(x, 2) + ' = ' + fA(pacN) + ' (' + fuentePAC + ', ponderado por cuánto trae la pasta).');
    r.pasos.push('Azúcar agregada: ' + f1(A) + ' − ' + f1(azPropio) + ' propios del fruto = ' + f1(azAgregado) + ' g, que suman ' + fA(pacAz) + ' de PAC. Total: ' + fA(pac.c) + '.');
    if (aceite < -2) r.avisos.push({ tipo: 'alerta', texto: 'La grasa declarada es menor que la que traería esa cantidad de ' + n.nombre.toLowerCase() + '. Revisa el % de fruto seco o la grasa.' });
    if (!n.escuela) r.avisos.push({ tipo: 'info', texto: 'Para ' + n.nombre.toLowerCase() + ' la escuela no tiene un valor fijo: el PAC sale del coeficiente 1,4 sobre la grasa.' });
    var ST = e.humedad !== null ? 100 - e.humedad : (G + P + (p.hidratosDisp !== null ? p.hidratosDisp : A) + (p.fibra || 0));
    chequeoEnergia(r, p.energia, 4 * P + 4 * (p.hidratosDisp !== null ? p.hidratosDisp : A) + 9 * G + 2 * (p.fibra || 0));
    r.ok = true;
    r.ficha = { pod: rango(A, A * 0.95, A * (mono ? 1.1 : 1.02)), pac: pac, grasa: G, st: ST, lac: lac, prot: P };
    r.origen = { pod: 'deducido', pac: via === 'declarado' ? origenPAC : 'supuesto', grasa: 'etiqueta', st: 'deducido', lac: conLeche ? 'supuesto' : 'deducido', prot: 'etiqueta' };
    r.comp = [{ nombre: n.nombre, v: pacN, clase: 'seg-negativo' }, { nombre: 'Azúcares', v: pacAz, clase: 'seg-azucar' }];
    r.azucares = A;
    return r;
  }

  /* --- Chocolate --- */
  function resolver3(a, b) {
    // a: matriz 3x3, b: vector 3 (Cramer)
    function det(m) { return m[0][0] * (m[1][1] * m[2][2] - m[1][2] * m[2][1]) - m[0][1] * (m[1][0] * m[2][2] - m[1][2] * m[2][0]) + m[0][2] * (m[1][0] * m[2][1] - m[1][1] * m[2][0]); }
    var D = det(a);
    if (Math.abs(D) < 1e-9) return null;
    var x = [];
    for (var k = 0; k < 3; k++) {
      var m = a.map(function (fila, i) { return fila.map(function (v, j) { return j === k ? b[i] : v; }); });
      x.push(det(m) / D);
    }
    return x;
  }

  function calcChocolate(e, overrides) {
    var r = nuevo();
    var tipo = e.tipoChoc || 'amargo';
    validarNumeros(r, e, ['cacao', 'grasa', 'proteina', 'azucares', 'colesterol', 'humedad']);
    if (r.errores.length) return r;
    var req = ['grasa', 'proteina', 'azucares'];
    if (tipo !== 'blanco' && tipo !== 'polvo') req.unshift('cacao');
    requerir(r, e, req);
    if (r.faltan.length) return r;
    var G = e.grasa, P = e.proteina, A = e.azucares;
    var cacaoPct = tipo === 'polvo' ? (e.cacao !== null ? e.cacao : 100) : e.cacao;
    var lista = e.ingredientes ? analizarLista(e.ingredientes, overrides) : [];
    r.chips = chipsDe(lista);
    var ids = idsDe(lista);
    var conVegetal = ids.indexOf('grasaVegetal') >= 0;
    var MC, CSG, SL = 0, GL = 0, lac = rango(0), origen = 'deducido', escenarios = null;
    var hum = e.humedad !== null ? e.humedad : (tipo === 'polvo' ? 3 : 1);

    if (tipo === 'amargo' || tipo === 'polvo') {
      MC = G; CSG = cacaoPct - MC;
      if (tipo === 'polvo') CSG = cacaoPct - MC;
      r.pasos.push('En un ' + (tipo === 'polvo' ? 'cacao en polvo' : 'chocolate sin leche') + ' toda la grasa es manteca de cacao: ' + f1(MC) + ' g.');
      r.pasos.push('Cacao sin grasa = ' + f1(cacaoPct) + '% de cacao − ' + f1(MC) + ' de manteca = ' + f1(CSG) + ' g.');
      if (CSG < 0) { r.errores.push({ campo: 'cacao', texto: 'El % de cacao es menor que la grasa. Revisa los dos valores o si lleva grasa vegetal.' }); return r; }
      if (ids.some(function (id) { return id === 'grasaLactea' || id === 'lpe' || id === 'leche' || id === 'crema'; })) r.avisos.push({ tipo: 'alerta', texto: 'La lista trae lácteos: si es un chocolate con leche, elige ese tipo.', accion: { campo: 'tipoChoc', valor: 'leche', texto: 'Cambiar a chocolate con leche' } });
    } else if (tipo === 'blanco') {
      if (cacaoPct !== null) {
        MC = cacaoPct; GL = Math.max(0, G - MC); SL = GL / K.LPE.grasa;
        r.pasos.push('En el chocolate blanco todo el cacao es manteca: ' + f1(MC) + ' g. La grasa restante, ' + f1(GL) + ' g, es grasa láctea.');
        var SLp = P / K.LPE.prot;
        if (Math.abs(SLp - SL) / Math.max(SL, 1) > 0.25) r.avisos.push({ tipo: 'alerta', texto: 'La proteína sugiere ' + f1(SLp) + ' g de sólidos lácteos y la grasa ' + f1(SL) + ' g. Puede llevar leche descremada o grasa vegetal: el resultado es menos preciso.' });
      } else {
        SL = P / K.LPE.prot; GL = SL * K.LPE.grasa; MC = Math.max(0, G - GL);
        r.pasos.push('Sin el % de cacao, usamos la proteína como testigo de la leche: ' + f1(P) + ' ÷ 0,263 = ' + f1(SL) + ' g de sólidos lácteos, con ' + f1(GL) + ' g de grasa láctea. La manteca de cacao es el resto: ' + f1(MC) + ' g.');
        origen = 'supuesto';
      }
      CSG = 0;
      lac = rango(SL * K.LPE.lac);
    } else {
      // Chocolate con leche
      var descremada = ids.indexOf('lpd') >= 0 && (ids.indexOf('grasaLactea') >= 0 || ids.indexOf('crema') >= 0 || ids.indexOf('cremaPolvo') >= 0) && ids.indexOf('lpe') < 0;
      if (!descremada) {
        var sol = resolver3([[1, 1, 0], [1, 0, K.LPE.grasa], [0, K.PROT_CSG, K.LPE.prot]], [cacaoPct, G, P]);
        if (!sol) { r.errores.push({ campo: 'cacao', texto: 'No pudimos separar los componentes.' }); return r; }
        MC = sol[0]; CSG = sol[1]; SL = sol[2]; GL = SL * K.LPE.grasa;
        r.pasos.push('Tres datos de la etiqueta, tres ecuaciones: % de cacao = manteca + cacao sin grasa; grasa = manteca + 0,267 × sólidos lácteos; proteína = 0,263 × sólidos lácteos + 0,227 × cacao sin grasa.');
        r.pasos.push('Resultado: ' + f1(MC) + ' g de manteca de cacao, ' + f1(CSG) + ' g de cacao sin grasa y ' + f1(SL) + ' g de sólidos lácteos, con ' + f1(GL) + ' g de grasa láctea.');
        r.avisos.push({ tipo: 'info', texto: 'El % de cacao de la etiqueta suele ser un mínimo. Si el real es 1 a 2 puntos mayor, el PAC baja unos 2 a 4 puntos.' });
        if (e.colesterol !== null) {
          var glCol = e.colesterol / K.COLESTEROL_GL;
          r.pasos.push('Verificación con el colesterol: ' + fmt(e.colesterol, 0) + ' mg ÷ 2,65 = ' + f1(glCol) + ' g de grasa láctea.');
          r.avisos.push({ tipo: Math.abs(glCol - GL) <= Math.max(2.5, GL * 0.4) ? 'ok' : 'alerta', texto: 'El colesterol indica ~' + f1(glCol) + ' g de grasa láctea y las ecuaciones ' + f1(GL) + ' g. ' + (Math.abs(glCol - GL) <= Math.max(2.5, GL * 0.4) ? 'Coinciden dentro del redondeo de la etiqueta.' : 'No coinciden: puede llevar grasa vegetal o leche descremada.') });
        }
        lac = rango(SL * K.LPE.lac);
      } else {
        var resolverCon = function (gl) {
          return resolver3([[1, 1, 0], [1, 0, K.LPD.grasa], [0, K.PROT_CSG, K.LPD.prot]], [cacaoPct, G - gl, P]);
        };
        if (e.colesterol !== null) {
          GL = e.colesterol / K.COLESTEROL_GL;
          var s2 = resolverCon(GL);
          MC = s2[0]; CSG = s2[1]; SL = s2[2];
          r.pasos.push('La lista trae leche descremada y grasa láctea por separado. El colesterol solo viene de la grasa animal: ' + fmt(e.colesterol, 0) + ' mg ÷ 2,65 = ' + f1(GL) + ' g de grasa láctea.');
          r.pasos.push('Con eso, ' + f1(MC) + ' g de manteca de cacao, ' + f1(CSG) + ' g de cacao sin grasa y ' + f1(SL) + ' g de leche descremada en polvo.');
          lac = rango(SL * K.LPD.lac);
          origen = 'supuesto';
        } else {
          var sa = resolverCon(3.5), sb = resolverCon(8);
          escenarios = [sa, sb];
          GL = 5.75; var s3 = resolverCon(GL);
          MC = s3[0]; CSG = s3[1]; SL = s3[2];
          lac = rango(SL * K.LPD.lac, Math.min(sa[2], sb[2]) * K.LPD.lac, Math.max(sa[2], sb[2]) * K.LPD.lac);
          origen = 'supuesto';
          r.pasos.push('La lista trae leche descremada y grasa láctea por separado, y la etiqueta no trae colesterol para separarlas. Calculamos entre 3,5 g (mínimo legal en Europa) y 8 g de grasa láctea.');
          r.avisos.push({ tipo: 'info', texto: 'Si la etiqueta trae colesterol, escríbelo: con él la grasa láctea sale exacta.', accion: { foco: 'colesterol', texto: 'Escribir el colesterol' } });
        }
      }
      if (MC < 0 || CSG < -0.5 || SL < 0) { r.errores.push({ campo: 'cacao', texto: 'Los datos no cuadran con un chocolate con leche. Revisa el % de cacao, la grasa y la proteína.' }); return r; }
      CSG = Math.max(0, CSG);
    }
    if (conVegetal) r.avisos.push({ tipo: 'alerta', texto: 'Lleva grasa vegetal: parte de la grasa no es manteca de cacao y el PAC negativo puede quedar exagerado.' });

    var lacC = lac.c, sac = Math.max(0, A - lacC);
    var negativo = -(CSG * K.CORVITTO_CSG + MC * K.CORVITTO_MC);
    var pacC = negativo + sac + lacC;
    var pac = rango(pacC), pod = rango(sac + lacC * K.POD_LACTOSA);
    if (escenarios) {
      var pacs = escenarios.map(function (s) { var l = s[2] * K.LPD.lac; return -(Math.max(0, s[1]) * K.CORVITTO_CSG + s[0] * K.CORVITTO_MC) + A; });
      pac = rango(pacC, Math.min.apply(null, pacs), Math.max.apply(null, pacs));
    }
    r.pasos.push('Fórmula de Corvitto: −(' + f1(CSG) + ' × 1,8 + ' + f1(MC) + ' × 0,9) = ' + fA(negativo) + '.' + (tipo === 'leche' || tipo === 'blanco' ? ' La grasa láctea no resta, igual que en la crema.' : ''));
    r.pasos.push('Azúcares: ' + (lacC > 0.1 ? f1(lacC) + ' g de lactosa y ' + f1(sac) + ' g de azúcar' : f1(A) + ' g de azúcar') + ', que suman ' + fA(sac + lacC) + ' de PAC. PAC neto = ' + fA(pacC) + '. POD = ' + fA(pod.c) + '.');
    r.ok = true;
    r.ficha = { pod: pod, pac: pac, grasa: G, st: 100 - hum, lac: lac, prot: P };
    r.origen = { pod: 'deducido', pac: origen, grasa: 'etiqueta', st: e.humedad !== null ? 'etiqueta' : 'supuesto', lac: tipo === 'amargo' || tipo === 'polvo' ? 'deducido' : origen, prot: 'etiqueta' };
    r.comp = [{ nombre: 'Cacao', v: negativo, clase: 'seg-negativo' }, { nombre: 'Azúcares', v: sac, clase: 'seg-azucar' }];
    if (lacC > 0.1) r.comp.push({ nombre: 'Lactosa', v: lacC, clase: 'seg-lactosa' });
    r.azucares = A;
    r.detalle = { MC: MC, CSG: CSG, SL: SL, GL: GL };
    return r;
  }

  /* --- Alcoholes --- */
  function calcAlcoholes(e) {
    var r = nuevo();
    var tipo = e.tipoAlc || 'destilado';
    validarNumeros(r, e, ['grados', 'azucares', 'grasa', 'proteina']);
    if (r.errores.length) return r;
    requerir(r, e, ['grados']);
    if (tipo !== 'destilado') requerir(r, e, ['azucares']);
    if (tipo === 'crema') requerir(r, e, ['grasa', 'proteina']);
    if (r.faltan.length) return r;
    if (e.grados > 96) { r.errores.push({ campo: 'grados', texto: 'Los grados no pueden pasar de 96.' }); return r; }
    var alc = e.grados * K.DENS_ALCOHOL, pacAl = alc * K.PAC_ALCOHOL;
    var A = tipo === 'destilado' ? (e.azucares || 0) : e.azucares;
    var G = tipo === 'crema' ? e.grasa : (e.grasa || 0), P = tipo === 'crema' ? e.proteina : (e.proteina || 0);
    var facPac = tipo === 'vino' ? K.FRUTA_PAC : 1, facPod = tipo === 'vino' ? K.FRUTA_POD : 1;
    var lac = 0;
    if (tipo === 'crema') lac = Math.min(P * K.LACTOSA_PROT.c, A);
    var sac = A - lac;
    var pacAz = tipo === 'vino' ? A * facPac : sac + lac;
    var pod = tipo === 'vino' ? A * facPod : sac + lac * K.POD_LACTOSA;
    r.pasos.push('Convención de la escuela: ' + f1(e.grados) + '° × 0,78 = ' + f1(alc) + ' g de alcohol por 100 ml (se toman como 100 g).');
    r.pasos.push('El alcohol es una molécula chica: cada gramo anticongela 7,43 veces más que el azúcar. ' + f1(alc) + ' × 7,43 = ' + fA(pacAl) + ' de PAC.');
    if (A > 0) r.pasos.push(tipo === 'vino'
      ? 'El azúcar residual del vino es glucosa y fructosa: ' + f1(A) + ' × 1,88 = ' + fA(pacAz) + ' de PAC y ' + f1(A) + ' × 1,44 = ' + fA(pod) + ' de POD.'
      : (tipo === 'crema' ? 'La lactosa sale de la proteína (× 1,5): ' + f1(lac) + ' g; el resto es azúcar. ' : '') + 'Los azúcares suman ' + fA(pacAz) + ' de PAC.');
    r.pasos.push('Los dos aportes se suman: PAC = ' + fA(pacAl + pacAz) + '. El alcohol no cuenta como sólido ni suma dulzor.');
    r.ok = true;
    var ST = A + G + P;
    r.ficha = { pod: rango(pod), pac: rango(pacAl + pacAz), grasa: G, st: ST, lac: rango(lac), prot: P };
    r.origen = { pod: 'deducido', pac: 'deducido', grasa: tipo === 'crema' ? 'etiqueta' : 'deducido', st: 'deducido', lac: tipo === 'crema' ? 'supuesto' : 'deducido', prot: tipo === 'crema' ? 'etiqueta' : 'deducido' };
    r.comp = [{ nombre: 'Alcohol', v: pacAl, clase: 'seg-alcohol' }];
    if (pacAz > 0.05) r.comp.push({ nombre: 'Azúcares', v: pacAz, clase: 'seg-azucar' });
    r.azucares = A;
    return r;
  }

  /* --- Azúcares y edulcorantes --- */
  var LISTA_AZUCARES = ['sacarosa', 'dextrosa', 'dextrosaAnhidra', 'fructosa', 'glucosaLiquida40', 'glucosaLiquida60', 'glucosaAtom33',
    'glucosaAtom38', 'glucosaAtom40', 'maltodextrina', 'maltodextrina12', 'invertido', 'jmaf', 'miel', 'lactosa', 'trehalosa', 'eritritol', 'sorbitol', 'maltitol', 'xilitol',
    'isomalt', 'alulosa', 'inulina', 'polidextrosa'];
  var AZUCARES = {
    sacarosa: { nombre: 'Sacarosa (azúcar)', pod: 100, pac: 100, st: 100, pm: 342, nota: 'Es la referencia: vale 100 en las dos escalas.' },
    dextrosa: { nombre: 'Dextrosa monohidratada', pod: 80, pac: 173, st: 91, pm: 180, nota: 'Es la dextrosa más común en el mercado y la que recomendamos. La anhidra, sin agua, vale 190: 10 g de anhidra equivalen a unos 11 g de monohidratada.' },
    dextrosaAnhidra: { nombre: 'Dextrosa anhidra', pod: 88, pac: 190, st: 100, pm: 180 },
    fructosa: { nombre: 'Fructosa', pod: 170, pac: 190, st: 100, pm: 180 },
    glucosaLiquida40: { nombre: 'Jarabe de glucosa DE 40 (líquido, 80% sólidos)', pod: 32, pac: 61, st: 80, esc: true, nota: 'Valor sobre el jarabe tal cual, con su agua. Seco (deshidratado) vale 45 y 76. A mayor DE, más dulzor y más PAC.' },
    glucosaLiquida60: { nombre: 'Jarabe de glucosa DE 60 (80% sólidos)', pod: 57, pac: 114, st: 80, esc: true, nota: 'Valor de la tabla de la escuela. A mayor DE, más dulzor y más PAC.' },
    glucosaAtom33: { nombre: 'Glucosa atomizada DE 33', pod: 24, pac: 56, st: 96, esc: true, nota: 'Valor de la tabla de la escuela.' },
    glucosaAtom38: { nombre: 'Glucosa atomizada DE 38', pod: 29, pac: 68, st: 96, esc: true, nota: 'Valor de la tabla de la escuela.' },
    glucosaAtom40: { nombre: 'Glucosa deshidratada DE 40', pod: 45, pac: 76, st: 96, esc: true, nota: 'Es el jarabe de glucosa DE 40 sin su agua. En líquido, con 80% de sólidos, vale 32 y 61.' },
    maltodextrina: { nombre: 'Maltodextrina DE 18', pod: 10, pac: 34, st: 95, esc: true, nota: 'Moléculas largas: aporta sólidos con poco dulzor y poco PAC. A mayor DE, más dulzor.' },
    maltodextrina12: { nombre: 'Maltodextrina DE 12', pod: 5, pac: 23, st: 95, esc: true, nota: 'Moléculas largas: aporta sólidos con poco dulzor y poco PAC. A mayor DE, más dulzor.' },
    invertido: { nombre: 'Azúcar invertido (jarabe, 78% sólidos)', pod: 120, pac: 190, st: 78, esc: true, nota: 'Valor sobre el jarabe tal cual: es un 20% más dulce que el azúcar y anticongela casi el doble.' },
    jmaf: { nombre: 'Jarabe de alta fructosa (76% sólidos)', pod: 91, pac: 144, st: 76 },
    miel: { nombre: 'Miel (82% azúcares)', pod: 118, pac: 154, st: 82, nota: 'Convención de fruta: azúcares × 1,44 y × 1,88.' },
    lactosa: { nombre: 'Lactosa', pod: 16, pac: 100, st: 100, pm: 342 },
    trehalosa: { nombre: 'Trehalosa', pod: 45, pac: 100, st: 100, pm: 342 },
    eritritol: { nombre: 'Eritritol', pod: 65, pac: 280, st: 100, pm: 122, nota: 'Molécula muy chica: anticongela casi el triple que el azúcar.' },
    sorbitol: { nombre: 'Sorbitol', pod: 60, pac: 188, st: 100, pm: 182 },
    maltitol: { nombre: 'Maltitol', pod: 90, pac: 99, st: 100, pm: 344 },
    xilitol: { nombre: 'Xilitol', pod: 100, pac: 225, st: 100, pm: 152 },
    isomalt: { nombre: 'Isomalt', pod: 50, pac: 99, st: 100, pm: 344 },
    alulosa: { nombre: 'Alulosa', pod: 70, pac: 190, st: 100, pm: 180 },
    inulina: { nombre: 'Inulina', pod: 10, pac: 5, st: 95, esc: true, nota: 'Cadenas largas de fructosa: casi no anticongela. Dosis habitual: 20 a 50 g por kilo.' },
    polidextrosa: { nombre: 'Polidextrosa', pod: 0, pac: 15, st: 96, nota: 'PAC estimado.' }
  };
  function calcAzucares(e) {
    var r = nuevo();
    var a = AZUCARES[e.azucar];
    if (!a) { r.faltan.push({ campo: 'azucar' }); return r; }
    r.pasos.push(a.pm ? 'El PAC sale de su peso molecular: 342 ÷ ' + a.pm + ' × 100 = ' + fmt(342 / a.pm * 100, 0) + (a.st < 100 ? ', y como trae ' + fmt(100 - a.st, 0) + '% de agua queda en ' + a.pac : '') + '.' : 'Valor de referencia.');
    if (a.nota) r.pasos.push(a.nota);
    r.pasos.push('POD ' + a.pod + ', PAC ' + a.pac + ' y ' + a.st + ' g de sólidos por 100 g.');
    r.ok = true;
    r.ficha = { pod: rango(a.pod), pac: rango(a.pac), grasa: 0, st: a.st, lac: rango(e.azucar === 'lactosa' ? 100 : 0), prot: 0 };
    r.origen = { pod: a.esc ? 'escuela' : 'tabla', pac: a.esc ? 'escuela' : a.pm ? 'deducido' : 'tabla', grasa: 'tabla', st: 'tabla', lac: 'tabla', prot: 'tabla' };
    r.comp = [{ nombre: a.nombre, v: a.pac, clase: 'seg-azucar' }];
    r.azucares = null;
    r.referencia = true;
    return r;
  }

  /* --- Pastas y bases: reconstrucción --- */
  function chipsDe(lista) {
    var out = [];
    lista.forEach(function (g, gi) {
      g.vars.forEach(function (v) {
        out.push({ texto: v.etiqueta, clave: v.clave, rec: v.rec, entrada: v.rec ? POR_ID[v.rec.entrada] : null, compuesto: !!g.compuesto, grupo: g.etiqueta, quid: v.quid !== null && v.quid !== undefined ? v.quid : (g.vars.length === 1 ? g.quid : null) });
      });
    });
    return out;
  }
  function idsDe(lista) {
    var ids = [];
    lista.forEach(function (g) { g.vars.forEach(function (v) { if (v.rec) ids.push(v.rec.entrada); }); });
    return ids;
  }

  function calcReconstruccion(e, overrides, esBase) {
    var r = nuevo();
    validarNumeros(r, e, ['energia', 'proteina', 'grasa', 'hidratos', 'azucares', 'fibra', 'humedad', 'alcoholVol']);
    if (r.errores.length) return r;
    requerir(r, e, ['proteina', 'grasa', 'hidratos', 'azucares']);
    if (!e.ingredientes || !e.ingredientes.trim()) r.faltan.push({ campo: 'ingredientes', nota: 'Con la lista reconstruimos la receta del producto.' });
    if (r.faltan.length) return r;
    var p = porCien(e);
    if (p.azucares > p.hidratosDisp + 0.5) { r.errores.push({ campo: 'azucares', texto: 'Los azúcares no pueden ser más que los hidratos.' }); return r; }
    var lista = analizarLista(e.ingredientes, overrides);
    r.chips = chipsDe(lista);
    if (!lista.length) { r.faltan.push({ campo: 'ingredientes' }); return r; }
    var desconocidos = r.chips.filter(function (c) { return !c.entrada; });
    if (desconocidos.length) {
      r.avisos.push({ tipo: 'fuerte', texto: 'No reconocimos ' + (desconocidos.length === 1 ? 'un ingrediente' : desconocidos.length + ' ingredientes') + ': ' + desconocidos.map(function (c) { return '“' + c.texto + '”'; }).join(', ') + '. Elige qué es en la lista de abajo para que entre al cálculo.' });
      r.esperandoChips = true;
      return r;
    }
    var et = { energia: p.energia, proteina: p.proteina, grasa: p.grasa, hidratos: p.hidratos, hidratosDisp: p.hidratosDisp, azucares: p.azucares, fibra: p.fibra, humedad: e.humedad, alcoholVol: e.alcoholVol };
    var rec = reconstruir(lista, et);
    if (!rec.ok) {
      r.errores.push({ campo: 'ingredientes', texto: 'Ninguna receta con esos ingredientes cuadra con la etiqueta, ni aflojando las tolerancias. Revisa que los valores sean por 100 g y que la lista esté completa.' });
      return r;
    }
    var R = rec.res;
    var pac = rango((R.pac.min + R.pac.max) / 2, R.pac.min, R.pac.max);
    var pod = rango((R.pod.min + R.pod.max) / 2, R.pod.min, R.pod.max);
    var lac = rango((R.lac.min + R.lac.max) / 2, R.lac.min, R.lac.max);
    var alc = rango((R.alc.min + R.alc.max) / 2, R.alc.min, R.alc.max);
    var ST = e.humedad !== null ? 100 - e.humedad - alc.c : p.grasa + p.proteina + p.hidratosDisp + (p.fibra || 0);
    // Receta reconstruida
    var cx = rec.central ? rec.central.x : null;
    r.receta = lista.map(function (g, gi) {
      var c = 0;
      if (cx) rec.vars.forEach(function (v, i) { if (v.g === gi) c += cx[i]; });
      var unico = g.vars.length === 1 && g.vars[0].rec ? POR_ID[g.vars[0].rec.entrada] : null;
      var nombre = unico && unico.grupo !== 'Aditivos' ? unico.nombre : (unico ? unico.nombre + ' (' + g.etiqueta + ')' : g.etiqueta);
      return { nombre: nombre, original: g.etiqueta, min: Math.max(0, R.grupos[gi].min), max: R.grupos[gi].max, c: c };
    });
    // Composición del PAC (en la receta central)
    var porClase = {};
    var claseDe = function (en) {
      if (!en) return ['Otros', 'seg-otros'];
      if (en.alcohol) return ['Alcohol', 'seg-alcohol'];
      if (en.negativo && en.c.pac < 0) return [en.grupo === 'Frutos secos' ? 'Frutos secos' : 'Cacao', 'seg-negativo'];
      if (en.grupo === 'Lácteos') return ['Lácteos', 'seg-lactosa'];
      if (en.grupo === 'Azúcares y edulcorantes' || en.grupo === 'Frutas') return ['Azúcares', 'seg-azucar'];
      if (en.c.acid > 50) return ['Ácidos', 'seg-acido'];
      return ['Otros', 'seg-otros'];
    };
    if (cx) {
      rec.vars.forEach(function (v, i) {
        var c = rec.comp(v, rec.central.combo);
        if (!c) return;
        var aporte = cx[i] * c.pac / 100;
        var cl = claseDe(v.e);
        if (!porClase[cl[0]]) porClase[cl[0]] = { nombre: cl[0], v: 0, clase: cl[1] };
        porClase[cl[0]].v += aporte;
      });
    }
    r.comp = Object.keys(porClase).map(function (k) { return porClase[k]; }).filter(function (s) { return Math.abs(s.v) >= 0.3; });
    // Pasos
    var nCorr = r.chips.filter(function (c) { return c.rec && c.rec.como === 'corregido'; }).length;
    var nCod = r.chips.filter(function (c) { return c.rec && c.rec.como === 'codigo'; }).length;
    r.pasos.push('Leímos la lista: ' + r.chips.length + ' ingredientes reconocidos' + (nCorr ? ', ' + nCorr + ' con la escritura corregida' : '') + (nCod ? ', ' + nCod + ' por su código E o INS' : '') + '.');
    var ecs = ['grasa', 'proteína', 'hidratos', 'azúcares'];
    if (et.energia !== null) ecs.push('calorías');
    if (et.humedad !== null) ecs.push('humedad');
    if (et.alcoholVol !== null) ecs.push('alcohol');
    r.pasos.push('La etiqueta da ' + ecs.length + ' condiciones (' + ecs.join(', ') + ') y el orden de la lista dice que cada ingrediente pesa al menos lo mismo que el siguiente.');
    r.pasos.push('Buscamos todas las recetas posibles que cumplen esas condiciones' + (rec.combosProbados > 1 ? ', probando ' + rec.combosProbados + ' combinaciones para los ingredientes ambiguos' : '') + '. Entre todas, el PAC va de ' + fA(pac.min) + ' a ' + fA(pac.max) + ' y el POD de ' + fA(pod.min) + ' a ' + fA(pod.max) + '.');
    Object.keys(rec.variantesOk).forEach(function (id) {
      var tot = POR_ID[id].variantes.length, ok = rec.variantesOk[id];
      if (ok.length < tot) r.pasos.push('“' + POR_ID[id].nombre + '” puede ser varias cosas; con esta etiqueta solo cuadra como ' + ok.join(' o ') + '.');
    });
    if (alc.max > 0.3) r.pasos.push('Alcohol: entre ' + f1(alc.min) + ' y ' + f1(alc.max) + ' g por 100 g, que aportan entre ' + fA(alc.min * K.PAC_ALCOHOL) + ' y ' + fA(alc.max * K.PAC_ALCOHOL) + ' de PAC.');
    r.pasos.push('Mostramos el centro del rango: PAC ' + fA(pac.c) + ', POD ' + fA(pod.c) + '.');
    if (rec.nivel > 0) r.avisos.push({ tipo: 'alerta', texto: 'La etiqueta no cuadraba del todo con su lista, así que aflojamos algunas condiciones (' + rec.nombreNivel + '). El resultado es menos preciso.' });
    var negativos = r.chips.filter(function (c) { return c.entrada && c.entrada.negativo; });
    if (negativos.length) r.avisos.push({ tipo: 'info', texto: 'Lleva ' + negativos.map(function (c) { return c.entrada.nombre.toLowerCase(); }).filter(function (v, i, a) { return a.indexOf(v) === i; }).join(' y ') + ', que restan PAC: ya está descontado.' });
    var intensos = r.chips.filter(function (c) { return c.entrada && c.entrada.intenso; });
    if (intensos.length) r.avisos.push({ tipo: 'alerta', texto: 'Lleva edulcorante intenso: endulza mucho en cantidades mínimas que la etiqueta no declara, así que su dulzor no está en el POD.' });
    var notas = r.chips.filter(function (c) { return c.entrada && (c.entrada.nota || c.entrada.sinValor); });
    notas.forEach(function (c) { r.avisos.push({ tipo: 'info', texto: c.entrada.nombre + ': ' + (c.entrada.nota || 'sin valor de PAC de la escuela, se toma como 0') + '.' }); });
    var Ecalc = 4 * p.proteina + 4 * p.hidratosDisp + 9 * p.grasa + 2 * (p.fibra || 0) + 7 * alc.c;
    if (p.energia !== null) {
      var dif = p.energia - Ecalc, tol = Math.max(5, 0.1 * p.energia);
      if (Math.abs(dif) <= tol) r.avisos.push({ tipo: 'ok', texto: 'Las calorías cuadran con la receta reconstruida' + (alc.c > 0.3 ? ', contando ' + f1(alc.c) + ' g de alcohol' : '') + '.' });
      else if (dif > tol && alc.max < 0.3) r.avisos.push({ tipo: 'alerta', texto: 'Faltan ' + fmt(dif, 0) + ' kcal en la cuenta y la lista no trae alcohol. Revisa si falta un ingrediente.' });
    }
    if (esBase) r.avisos.push({ tipo: 'info', texto: 'Mira la receta reconstruida: así sabes qué estás comprando en la base.' });
    r.ok = true;
    r.ficha = { pod: pod, pac: pac, grasa: p.grasa, st: ST, lac: lac, prot: p.proteina };
    r.origen = { pod: 'supuesto', pac: 'supuesto', grasa: 'etiqueta', st: 'deducido', lac: lac.max - lac.min > 0.3 ? 'supuesto' : 'deducido', prot: 'etiqueta' };
    r.azucares = p.azucares;
    r.rec = rec;
    return r;
  }

  /* =========================================================
     8. API
     ========================================================= */

  function calcular(cat, e, overrides) {
    switch (cat) {
      case 'lacteos': return calcLacteos(e, overrides);
      case 'fruta': return calcFruta(e);
      case 'frutos': return calcFrutos(e, overrides);
      case 'chocolate': return calcChocolate(e, overrides);
      case 'pastas': return calcReconstruccion(e, overrides, false);
      case 'bases': return calcReconstruccion(e, overrides, true);
      case 'alcoholes': return calcAlcoholes(e);
      case 'azucares': return calcAzucares(e);
    }
    return nuevo();
  }

  return {
    calcular: calcular, analizarLista: analizarLista, buscarNombre: buscarNombre, leerLista: leerLista,
    ENTRADAS: ENTRADAS, POR_ID: POR_ID, FRUTAS: FRUTAS, FRUTOS_SECOS: FRUTOS_SECOS, AZUCARES: AZUCARES, LISTA_AZUCARES: LISTA_AZUCARES,
    prepararLP: prepararLP, optimizar: optimizar, limpiar: limpiar, K: K
  };
})();

(function () {
  'use strict';
  var M = MOTOR;
  var $ = function (id) { return document.getElementById(id); };
  var reducir = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var NOMBRE_CAMPO = {
    energia: 'Energía', proteina: 'Proteínas', grasa: 'Grasa total', hidratos: 'Hidratos de carbono', azucares: 'Azúcares totales',
    fibra: 'Fibra dietética', densidad: 'Peso de 100 ml', cacao: '% de cacao', colesterol: 'Colesterol', grados: 'Grados de alcohol',
    brix: 'Lectura del refractómetro', acidez: 'Acidez', quidNuez: '% de fruto seco', humedad: 'Humedad', alcoholVol: 'Alcohol',
    ingredientes: 'Lista de ingredientes', fruta: 'Fruta', fruto: 'Fruto seco', azucar: 'Azúcar'
  };
  var ETIQUETA_ORIGEN = { etiqueta: 'De la etiqueta', deducido: 'Deducido', supuesto: 'Supuesto', tabla: 'Tabla', escuela: 'Valor de la escuela', medido: 'Medido' };
  var TITULOS = { lacteos: 'Tu lácteo', fruta: 'Tu fruta', frutos: 'Tu fruto seco', chocolate: 'Tu chocolate', pastas: 'Tu pasta', bases: 'Tu base', alcoholes: 'Tu bebida', azucares: 'Tu azúcar' };

  var EJEMPLOS = {
    lacteos: [
      { t: 'Leche entera', v: { subLac: 'sin', unidad: 'ml', densidad: '103', energia: '59', proteina: '3,1', grasa: '3,1', hidratos: '4,6', azucares: '4,6', ingredientes: 'Leche entera.', dosis: '600' } },
      { t: 'Dulce de leche', v: { subLac: 'con', unidad: 'g', energia: '300', proteina: '7', grasa: '7', hidratos: '52', azucares: '50', ingredientes: 'Leche entera, azúcar, bicarbonato de sodio.', dosis: '300' } },
      { t: 'Crema 35%', v: { subLac: 'sin', unidad: 'g', energia: '336', proteina: '2,2', grasa: '35', hidratos: '3', azucares: '3', ingredientes: 'Crema de leche, estabilizante (carragenina).', dosis: '150' } }
    ],
    fruta: [
      { t: 'Frutilla con tabla', v: { metFruta: 'tabla', fruta: 'frutilla', dosis: '300' } },
      { t: 'Limón con refractómetro', v: { metFruta: 'refracto', fruta: 'limon', brix: '8', acidez: '', formaFruta: 'jugo', dosis: '250' } },
      { t: 'Mango con refractómetro', v: { metFruta: 'refracto', fruta: 'mango', brix: '16', acidez: '', formaFruta: 'pulpa', dosis: '400' } }
    ],
    frutos: [
      { t: 'Pasta de pistacho pura', v: { fruto: 'pistacho', presNuez: 'pura', dosis: '100' } },
      { t: 'Crema de pistacho 45%', v: { fruto: 'pistacho', presNuez: 'mezcla', energia: '550', proteina: '9,1', grasa: '35', hidratos: '47,5', azucares: '43,5', fibra: '4,8', quidNuez: '', humedad: '', ingredientes: 'Pistacho 45%, azúcar, aceite de girasol, lecitina de girasol', dosis: '150' } }
    ],
    chocolate: [
      { t: 'Con leche 33,6% (ficha real)', v: { tipoChoc: 'leche', cacao: '33,6', grasa: '36,2', proteina: '7', azucares: '50', colesterol: '20', ingredientes: 'Azúcar, manteca de cacao, leche entera en polvo, pasta de cacao, emulsionante: lecitina de soja, aroma natural de vainilla', dosis: '150' } },
      { t: 'Amargo 70%', v: { tipoChoc: 'amargo', cacao: '70', grasa: '42', proteina: '9', azucares: '27', colesterol: '', ingredientes: '', dosis: '100' } },
      { t: 'Blanco 28%', v: { tipoChoc: 'blanco', cacao: '28', grasa: '34,5', proteina: '6,4', azucares: '55', colesterol: '', ingredientes: '', dosis: '150' } }
    ],
    pastas: [
      { t: 'Pasta tiramisú (ficha real)', v: { energia: '318', proteina: '2,4', grasa: '4,1', hidratos: '51', azucares: '39', fibra: '', humedad: '33', alcoholVol: '10,5', origen: 'latam',
        ingredientes: 'Sugar, egg-flavoured wine (wine, sugar, alcohol, fine Marsala wine, colour: caramel (E150d), powdered egg yolks, flavouring) (sulfur dioxide), Marsala wine (sulfur dioxide), glucose syrup, powdered egg yolk, water, alcohol, flavourings, colours: caramel (E150c), modified starch. May contain traces of soybeans, milk, almonds, hazelnuts, walnuts and pistachio nuts.', dosis: '74' } },
      { t: 'Crema de avellanas y cacao', v: { energia: '539', proteina: '6,3', grasa: '30,9', hidratos: '57,5', azucares: '56,3', fibra: '', humedad: '', alcoholVol: '', origen: 'latam',
        ingredientes: 'Azúcar, aceite de palma, avellanas 13%, cacao magro 7,4%, leche desnatada en polvo 6,6%, suero en polvo, lecitina de soja, vainillina', dosis: '100' } }
    ],
    bases: [
      { t: 'Base 50 (ficha real)', v: { energia: '405', proteina: '3,5', grasa: '9,5', hidratos: '75', azucares: '68', fibra: '', humedad: '4', alcoholVol: '', origen: 'latam',
        ingredientes: 'Dextrose, lactose, whey proteins, dried glucose syrup, skimmed milk powder, emulsifiers: acetic acid esters of mono- and diglycerides of fatty acids, lactic acid esters of mono- and diglycerides of fatty acids, stabilizers: mono- and diglycerides of fatty acids, carboxymethyl cellulose. Contains: MILK.', dosis: '38' } },
      { t: 'Base limón 50 (ficha real)', v: { energia: '209', proteina: '0,1', grasa: '0,8', hidratos: '50,6', azucares: '50,3', fibra: '0,8', humedad: '', alcoholVol: '', origen: 'latam',
        ingredientes: 'Destrosio, acido citrico, stabiliz.: E405, E412, E466, aromi, glucosio disidratato, emulsionante: E472b', dosis: '34' } },
      { t: 'Base 50 con proteínas (ficha real)', v: { energia: '366', proteina: '20,7', grasa: '2,5', hidratos: '65,8', azucares: '65,2', fibra: '0,1', humedad: '', alcoholVol: '', origen: 'latam',
        ingredientes: 'Glucosio in polvere, proteine del latte, latte spray magro, maltodestrina, emulsionanti: E471, E473, aromi', dosis: '38' } }
    ],
    alcoholes: [
      { t: 'Vodka 40°', v: { tipoAlc: 'destilado', grados: '40', azucares: '', grasa: '', proteina: '', dosis: '50' } },
      { t: 'Marsala', v: { tipoAlc: 'vino', grados: '17,5', azucares: '12', grasa: '', proteina: '', dosis: '80' } },
      { t: 'Licor de café', v: { tipoAlc: 'licor', grados: '20', azucares: '40', grasa: '', proteina: '', dosis: '60' } }
    ],
    azucares: [
      { t: 'Dextrosa', v: { azucar: 'dextrosa', dosis: '40' } },
      { t: 'Eritritol', v: { azucar: 'eritritol', dosis: '30' } },
      { t: 'Glucosa DE 40', v: { azucar: 'glucosaLiquida40', dosis: '50' } }
    ]
  };

  var estado = { cat: null, overrides: {} };
  var CAMPOS_TEXTO = ['unidad', 'densidad', 'energia', 'proteina', 'grasa', 'hidratos', 'azucares', 'fibra', 'humedad', 'alcoholVol', 'ingredientes', 'fruta', 'brix', 'acidez', 'fruto', 'quidNuez', 'cacao', 'colesterol', 'grados', 'azucar'];
  var RADIOS = ['subLac', 'metFruta', 'formaFruta', 'presNuez', 'tipoChoc', 'tipoAlc', 'origen'];

  /* ---- Selects ---- */
  M.FRUTAS.forEach(function (f) { var o = document.createElement('option'); o.value = f.id; o.textContent = f.nombre; $('fruta').appendChild(o); });
  M.FRUTOS_SECOS.forEach(function (n) { var o = document.createElement('option'); o.value = n.id; o.textContent = n.nombre; $('fruto').appendChild(o); });
  M.LISTA_AZUCARES.forEach(function (k) { var o = document.createElement('option'); o.value = k; o.textContent = M.AZUCARES[k].nombre; $('azucar').appendChild(o); });

  var OPCIONES_INGREDIENTES = (function () {
    var porGrupo = {};
    M.ENTRADAS.forEach(function (e) { (porGrupo[e.grupo] = porGrupo[e.grupo] || []).push(e); });
    return porGrupo;
  })();

  /* ---- Lectura ---- */
  function num(id) {
    var el = $(id); if (!el) return null;
    var v = el.value.trim().replace(/\s/g, '').replace(',', '.');
    if (v === '') return null;
    var n = Number(v);
    return isFinite(n) ? n : NaN;
  }
  function radio(name, def) { var el = document.querySelector('input[name="' + name + '"]:checked'); return el ? el.value : def; }
  function leer() {
    return {
      unidad: estado.cat === 'lacteos' ? $('unidad').value : 'g', densidad: num('densidad'), energia: num('energia'), proteina: num('proteina'), grasa: num('grasa'),
      hidratos: num('hidratos'), azucares: num('azucares'), fibra: num('fibra'), humedad: num('humedad'), alcoholVol: num('alcoholVol'),
      origen: radio('origen', 'latam'), ingredientes: $('ingredientes').value, subLac: radio('subLac', 'sin'), metFruta: radio('metFruta', 'tabla'),
      fruta: $('fruta').value, brix: num('brix'), acidez: num('acidez'), formaFruta: radio('formaFruta', 'pulpa'), fruto: $('fruto').value,
      presNuez: radio('presNuez', 'pura'), quidNuez: num('quidNuez'), tipoChoc: radio('tipoChoc', 'amargo'), cacao: num('cacao'),
      colesterol: num('colesterol'), tipoAlc: radio('tipoAlc', 'destilado'), grados: num('grados'), azucar: $('azucar').value
    };
  }

  /* ---- Visibilidad por categoría ---- */
  function mostrar(id, si) { var el = $(id); if (el) el.hidden = !si; }
  function visibilidad(e) {
    var c = estado.cat;
    var mezcla = c === 'frutos' && e.presNuez === 'mezcla';
    mostrar('bloqueLac', c === 'lacteos');
    mostrar('bloqueFruta', c === 'fruta');
    mostrar('filaRefracto', c === 'fruta' && e.metFruta === 'refracto');
    mostrar('bloqueFrutos', c === 'frutos');
    mostrar('filaQuid', mezcla);
    mostrar('bloqueChoc', c === 'chocolate');
    mostrar('bloqueAlc', c === 'alcoholes');
    mostrar('bloqueAzucar', c === 'azucares');
    var conEtiqueta = ['lacteos', 'chocolate', 'pastas', 'bases', 'alcoholes'].indexOf(c) >= 0 || mezcla;
    mostrar('bloqueEtiqueta', conEtiqueta);
    var filas = { unidad: c === 'lacteos', energia: c === 'lacteos' || c === 'pastas' || c === 'bases' || mezcla,
      proteina: c !== 'alcoholes' || e.tipoAlc === 'crema', grasa: c !== 'alcoholes' || e.tipoAlc === 'crema',
      hidratos: c === 'lacteos' || c === 'pastas' || c === 'bases' || mezcla, azucares: true,
      fibra: c === 'pastas' || c === 'bases' || mezcla, cacao: c === 'chocolate', colesterol: c === 'chocolate' && e.tipoChoc === 'leche' };
    Object.keys(filas).forEach(function (k) { mostrar('r-' + k, filas[k]); });
    mostrar('r-densidad', c === 'lacteos' && e.unidad === 'ml');
    $('notaEtiqueta').textContent = c === 'alcoholes'
      ? 'Valores por 100 ml, como vienen en la botella. Por convención se toman como 100 g.'
      : 'Usa la columna por 100 g, no la de la porción. Si un dato no viene en la etiqueta, déjalo vacío.';
    mostrar('bloqueOrigen', c === 'lacteos' || c === 'pastas' || c === 'bases');
    var conLista = ['lacteos', 'chocolate', 'pastas', 'bases'].indexOf(c) >= 0 || mezcla;
    mostrar('bloqueLista', conLista);
    var obligatoria = c === 'pastas' || c === 'bases';
    $('tituloLista').textContent = obligatoria ? 'Lista de ingredientes' : 'Lista de ingredientes (opcional)';
    $('ayudaLista').textContent = obligatoria
      ? 'Pégala tal cual, en el orden de la etiqueta. La leemos aunque tenga errores de escritura, en español, inglés o italiano, y con códigos E o INS.'
      : 'Si la pegas, detectamos cosas que cambian el cálculo, como azúcar agregada, suero o grasa vegetal.';
    mostrar('bloqueExtra', c === 'pastas' || c === 'bases' || mezcla);
    mostrar('c-alcohol', c === 'pastas' || c === 'bases');
  }

  /* ---- Pintar ---- */
  function fmt(v, d) {
    if (d === undefined) d = 1;
    if (Math.abs(v) < Math.pow(10, -d) / 2) v = 0;
    return v.toLocaleString('es-CL', { minimumFractionDigits: d, maximumFractionDigits: d }).replace(/^-/, '−');
  }
  function fA(v) { return Math.abs(v) < 9.95 ? fmt(v, 1) : fmt(v, 0); }

  function pintarDato(id, valor, origen, rango, auto) {
    var el = $(id);
    el.querySelector('.dato-valor').textContent = valor === null || valor === undefined ? '—' : (auto ? fA(valor) : fmt(valor));
    var o = el.querySelector('.origen');
    if (origen && valor !== null && valor !== undefined) { o.textContent = ETIQUETA_ORIGEN[origen] || origen; o.className = 'origen origen-' + origen; o.hidden = false; }
    else o.hidden = true;
    el.querySelector('.rango').textContent = rango && valor !== null && valor !== undefined
      ? 'entre ' + (auto ? fA(rango[0]) : fmt(rango[0])) + ' y ' + (auto ? fA(rango[1]) : fmt(rango[1])) : '';
  }
  function conRango(x, minimo) { return x.max - x.min >= Math.max(minimo, 0.03 * Math.abs(x.c)) ? [x.min, x.max] : null; }

  function avisoEl(a) {
    var d = document.createElement('div');
    d.className = 'aviso aviso-' + a.tipo;
    if (a.titulo) { var t = document.createElement('p'); t.className = 'aviso-titulo'; t.textContent = a.titulo; d.appendChild(t); }
    var p = document.createElement('p'); p.textContent = a.texto; d.appendChild(p);
    if (a.acciones && a.acciones.length) {
      var w = document.createElement('div'); w.className = 'acciones';
      a.acciones.forEach(function (ac) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'boton-linea boton-chico'; b.textContent = ac.texto;
        b.addEventListener('click', ac.fn); w.appendChild(b);
      });
      d.appendChild(w);
    }
    return d;
  }
  function enfocar(campo) {
    var el = $(campo) || document.querySelector('input[name="' + campo + '"]');
    if (!el) return;
    if (el.closest('[hidden]')) return;
    el.focus({ preventScroll: true });
    el.scrollIntoView({ block: 'center', behavior: reducir ? 'auto' : 'smooth' });
  }

  function pintarChips(chips) {
    var cont = $('chips');
    cont.innerHTML = '';
    $('chipsTitulo').hidden = !chips || !chips.length;
    if (!chips) return;
    chips.forEach(function (c) {
      var fila = document.createElement('div');
      var clase = !c.entrada ? 'desconocido' : c.rec.como === 'manual' ? 'manual' : c.rec.como === 'corregido' ? 'corregido' : '';
      fila.className = 'chip ' + clase;
      var tx = document.createElement('div'); tx.className = 'chip-texto';
      tx.textContent = c.texto + (c.quid !== null && c.quid !== undefined ? ' (' + fmt(c.quid, c.quid % 1 ? 1 : 0) + '%)' : '');
      var sm = document.createElement('small');
      sm.textContent = !c.entrada ? 'No lo reconocimos: elige qué es' : c.rec.como === 'corregido' ? 'Corregido: lo leímos como ' + c.rec.sinonimo
        : c.rec.como === 'codigo' ? 'Por su código ' + (c.rec.codigo || '').toUpperCase() : c.rec.como === 'manual' ? 'Elegido por ti' : (c.compuesto ? 'Dentro de: ' + c.grupo : '');
      if (sm.textContent) tx.appendChild(sm);
      var sel = document.createElement('select');
      sel.setAttribute('aria-label', 'Qué es ' + c.texto);
      var o0 = document.createElement('option'); o0.value = ''; o0.textContent = '¿Qué es?'; sel.appendChild(o0);
      Object.keys(OPCIONES_INGREDIENTES).forEach(function (g) {
        var og = document.createElement('optgroup'); og.label = g;
        OPCIONES_INGREDIENTES[g].forEach(function (e) { var o = document.createElement('option'); o.value = e.id; o.textContent = e.nombre; og.appendChild(o); });
        sel.appendChild(og);
      });
      sel.value = c.entrada ? c.entrada.id : '';
      sel.addEventListener('change', function () {
        if (sel.value) estado.overrides[c.clave] = sel.value; else delete estado.overrides[c.clave];
        actualizar(true);
      });
      fila.appendChild(tx); fila.appendChild(sel);
      cont.appendChild(fila);
    });
  }

  function limpiar() {
    ['d-pod', 'd-pac', 'd-grasa', 'd-st', 'd-lactosa', 'd-proteina'].forEach(function (id) { pintarDato(id, null); });
    ['secReceta', 'secComp'].forEach(function (id) { mostrar(id, false); });
  }

  function aplicarAccion(ac) {
    return function () {
      if (ac.campo) { var r = document.querySelector('input[name="' + ac.campo + '"][value="' + ac.valor + '"]'); if (r) r.checked = true; actualizar(true); }
      if (ac.foco) enfocar(ac.foco);
    };
  }

  function pintar(r, e) {
    var est = $('estado');
    est.innerHTML = '';
    pintarChips(r.chips);
    if (!r.ok) {
      limpiar();
      if (r.errores.length) {
        r.errores.forEach(function (er) {
          est.appendChild(avisoEl({ tipo: 'fuerte', texto: (NOMBRE_CAMPO[er.campo] ? NOMBRE_CAMPO[er.campo] + ': ' : '') + er.texto,
            acciones: NOMBRE_CAMPO[er.campo] ? [{ texto: 'Ir a ' + NOMBRE_CAMPO[er.campo].toLowerCase(), fn: function () { enfocar(er.campo); } }] : [] }));
        });
        return;
      }
      if (r.esperandoChips) { r.avisos.forEach(function (a) { est.appendChild(avisoEl(a)); }); return; }
      var vacio = r.faltan.length >= 3 && r.faltan.every(function (x) { return e[x.campo] === null || e[x.campo] === undefined || e[x.campo] === ''; });
      if (vacio) { est.appendChild(avisoEl({ tipo: 'info', texto: 'Completa los datos de tu ingrediente o prueba con uno de los ejemplos.' })); return; }
      var notas = r.faltan.map(function (x) { return x.nota; }).filter(Boolean);
      est.appendChild(avisoEl({
        tipo: 'alerta', titulo: 'Para calcular falta',
        texto: r.faltan.map(function (x) { return NOMBRE_CAMPO[x.campo] || x.campo; }).join(', ') + '.' + (notas.length ? ' ' + notas.join(' ') : '') + ' Si la etiqueta dice 0, escribe 0.',
        acciones: r.faltan.map(function (x) { return { texto: 'Completar ' + (NOMBRE_CAMPO[x.campo] || x.campo).toLowerCase(), fn: function () { enfocar(x.campo); } }; })
      }));
      return;
    }

    var F = r.ficha, O = r.origen;
    pintarDato('d-pod', F.pod.c, O.pod, conRango(F.pod, 1), true);
    pintarDato('d-pac', F.pac.c, O.pac, conRango(F.pac, 1), true);
    pintarDato('d-grasa', F.grasa, O.grasa);
    pintarDato('d-st', F.st, O.st);
    pintarDato('d-lactosa', F.lac.c, O.lac, F.lac.max - F.lac.min >= 0.3 ? [F.lac.min, F.lac.max] : null);
    pintarDato('d-proteina', F.prot, O.prot);

    var orden = { fuerte: 0, alerta: 1, ok: 2, info: 3 };
    r.avisos.slice().sort(function (a, b) { return orden[a.tipo] - orden[b.tipo]; }).forEach(function (a) {
      var acc = a.accion ? [{ texto: a.accion.texto, fn: aplicarAccion(a.accion) }] : [];
      est.appendChild(avisoEl({ tipo: a.tipo, texto: a.texto, acciones: acc }));
    });

    // Receta reconstruida
    if (r.receta && r.receta.length) {
      mostrar('secReceta', true);
      var tb = $('tablaReceta'); tb.innerHTML = '';
      var maxEscala = Math.max.apply(null, r.receta.map(function (x) { return x.max; }).concat([10]));
      r.receta.forEach(function (x) {
        var tr = document.createElement('tr');
        var td1 = document.createElement('td'); td1.className = 'nombre'; td1.textContent = x.nombre;
        if (x.original && x.original.toLowerCase() !== x.nombre.toLowerCase() && x.nombre.toLowerCase().indexOf(x.original.toLowerCase()) < 0) { var sm = document.createElement('small'); sm.style.cssText = 'display:block;color:var(--gris);font-size:12.5px'; sm.textContent = x.original; td1.appendChild(sm); }
        var td2 = document.createElement('td');
        var pista = document.createElement('div'); pista.className = 'pista';
        var tramo = document.createElement('div'); tramo.className = 'tramo';
        tramo.style.left = (x.min / maxEscala * 100) + '%';
        tramo.style.width = Math.max(0.8, (x.max - x.min) / maxEscala * 100) + '%';
        var punto = document.createElement('div'); punto.className = 'punto';
        punto.style.left = 'calc(' + (x.c / maxEscala * 100) + '% - 1px)';
        pista.appendChild(tramo); pista.appendChild(punto); td2.appendChild(pista);
        var td3 = document.createElement('td'); td3.className = 'cifra';
        td3.textContent = x.max - x.min < 0.6 ? fmt(x.c) + ' g' : fmt(x.min, x.min < 10 ? 1 : 0) + '–' + fmt(x.max, x.max < 10 ? 1 : 0) + ' g';
        tr.appendChild(td1); tr.appendChild(td2); tr.appendChild(td3);
        tb.appendChild(tr);
      });
    } else mostrar('secReceta', false);

    // Composición del PAC
    var comp = (r.comp || []).filter(function (s) { return Math.abs(s.v) >= 0.3; });
    var pos = comp.filter(function (s) { return s.v > 0; }), neg = comp.filter(function (s) { return s.v < 0; });
    var totalPos = pos.reduce(function (a, s) { return a + s.v; }, 0);
    var totalNeg = neg.reduce(function (a, s) { return a + s.v; }, 0);
    if (comp.length && !r.referencia) {
      mostrar('secComp', true);
      var barra = $('barraPac'), ley = $('leyendaPac');
      barra.innerHTML = ''; ley.innerHTML = '';
      var escala = totalPos + Math.abs(totalNeg);
      comp.forEach(function (s) {
        var sp = document.createElement('span'); sp.className = s.clase;
        sp.style.width = (Math.abs(s.v) / escala * 100) + '%';
        barra.appendChild(sp);
        var li = document.createElement('li'); var i = document.createElement('i'); i.className = s.clase; li.appendChild(i);
        li.appendChild(document.createTextNode(s.nombre + ': ' + (s.v > 0 ? '+' : '') + fA(s.v)));
        ley.appendChild(li);
      });
      barra.setAttribute('role', 'img');
      barra.setAttribute('aria-label', comp.map(function (s) { return s.nombre + ' ' + fA(s.v); }).join(', '));
      var frase = '';
      var alc = comp.filter(function (s) { return s.clase === 'seg-alcohol'; })[0];
      var acid = comp.filter(function (s) { return s.clase === 'seg-acido'; })[0];
      if (neg.length && totalPos < 0.5) frase = neg.map(function (s) { return s.nombre; }).join(' y ') + ' resta ' + fA(-totalNeg) + ' de PAC por cada 100 g: endurece el helado.';
      else if (neg.length) frase = neg.map(function (s) { return s.nombre.toLowerCase(); }).join(' y ').replace(/^./, function (c) { return c.toUpperCase(); }) + ' resta' + (neg.length > 1 ? 'n ' : ' ') + fA(-totalNeg) + ' de PAC: sin eso, este ingrediente tendría ' + fA(totalPos) + '.';
      else if (alc && totalPos && alc.v / totalPos >= 0.98) frase = 'Todo su poder anticongelante viene del alcohol.';
      else if (alc && totalPos && alc.v / totalPos >= 0.5) frase = 'Más de la mitad del poder anticongelante viene del alcohol, no del azúcar.';
      else if (r.frase) frase = r.frase;
      $('fraseComp').textContent = frase;
      mostrar('fraseComp', !!frase);
    } else mostrar('secComp', false);

  }

  /* ---- Ciclo ---- */
  var temporizador = null;
  function actualizar(inmediato) {
    if (!estado.cat) return;
    var e = leer();
    visibilidad(e);
    var pesado = estado.cat === 'pastas' || estado.cat === 'bases';
    clearTimeout(temporizador);
    var correr = function () {
      var r;
      try { r = M.calcular(estado.cat, e, estado.overrides); }
      catch (err) { r = { ok: false, faltan: [], errores: [{ campo: '', texto: 'Algo falló al calcular. Revisa los datos.' }], avisos: [], pasos: [] }; if (window.console) console.error(err); }
      pintar(r, e);
    };
    if (pesado && !inmediato) temporizador = setTimeout(correr, 350); else correr();
  }

  function elegirCategoria(cat, quieto) {
    estado.cat = cat;
    var r = document.querySelector('input[name="cat"][value="' + cat + '"]'); if (r) r.checked = true;
    $('trabajo').hidden = false;
    $('tituloCat').textContent = TITULOS[cat];
    var cont = $('ejemplos'); cont.innerHTML = '';
    var sp = document.createElement('span'); sp.className = 'ejemplos-texto'; sp.textContent = 'Prueba con'; cont.appendChild(sp);
    EJEMPLOS[cat].forEach(function (ej) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'boton-linea'; b.textContent = ej.t;
      b.addEventListener('click', function () { cargar(ej.v); });
      cont.appendChild(b);
    });
    CAMPOS_TEXTO.forEach(function (k) { if (['fruta', 'fruto', 'azucar', 'unidad'].indexOf(k) < 0) $(k).value = k === 'densidad' ? '100' : ''; });
    $('unidad').value = 'g';
    estado.overrides = {};
    actualizar(true);
    if (!quieto && window.matchMedia && window.matchMedia('(max-width: 940px)').matches) $('trabajo').scrollIntoView({ block: 'start', behavior: reducir ? 'auto' : 'smooth' });
  }

  function cargar(v, quieto) {
    CAMPOS_TEXTO.forEach(function (k) { if (k in v) $(k).value = v[k]; else if (['fruta', 'fruto', 'azucar', 'unidad'].indexOf(k) < 0) $(k).value = k === 'densidad' ? '100' : ''; });
    if (!('unidad' in v)) $('unidad').value = 'g';
    RADIOS.forEach(function (k) { if (k in v) { var r = document.querySelector('input[name="' + k + '"][value="' + v[k] + '"]'); if (r) r.checked = true; } });
    estado.overrides = {};
    actualizar(true);
    if (!quieto && window.matchMedia && window.matchMedia('(max-width: 940px)').matches) $('resultado').scrollIntoView({ block: 'start', behavior: reducir ? 'auto' : 'smooth' });
  }

  document.querySelectorAll('input[name="cat"]').forEach(function (r) {
    r.addEventListener('change', function () { elegirCategoria(r.value); });
  });
  $('formulario').addEventListener('input', function () { actualizar(false); });
  $('formulario').addEventListener('change', function () { actualizar(false); });
  $('formulario').addEventListener('submit', function (ev) { ev.preventDefault(); });

  window.__calc = { elegirCategoria: elegirCategoria, cargar: cargar, EJEMPLOS: EJEMPLOS, estado: estado, actualizar: actualizar };
})();
